<template>
  <div class="canvasContainer" ref="canvasContainer" @mouseleave="_ClearHoverCallout">

    <!-- Callout de hover del power block (componente de presentación). -->
    <ViewerHoverCallout v-if="hoverCallout" :callout="hoverCallout" />

    <!-- Popover del elemento (click en modo foco): info + historial + certificación. -->
    <ViewerElementPopover v-if="selectedElement"
      :source="selectedElement.source"
      :anchor="selectedElement.anchor"
      :box="selectedElement.box"
      :bounds="selectedElement.bounds"
      @epc-close="_CloseElementPopover" />

    <v-stage ref="stage"
      :config="configKonva"
      @wheel="handleWheel"
      @contextmenu="handleContextMenu"
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp"
      @mousemove="handleMouseOver"
      @click="handleClick"
      @dblclick="handleDblClick"
      @dragend="handleStageDragEnd"

      >

      <v-layer ref="refBlocks" :config="{ id: 'layerBg', name: 'layerBg', visible: showAreas }" :listening="false">
        <v-line v-for="block in blocks" :key="'block_' + block.id"
          :config="block"></v-line>

        <v-text v-for="txt in txtBlocks" :key="'txt_' + txt.id" :listening="false"
          :config="txt"></v-text>
      </v-layer>

      <v-layer ref="layer" :config="{ id: 'layerEntities', name: 'layerEntities' }">
        <!-- Los grupos y entidades se crean directamente con Konva API para mejor rendimiento -->
      </v-layer>

      <v-layer ref="refVectors" :config="{ id: 'layerVectors', name: 'layerVectors' }">
      </v-layer>

    </v-stage>
  </div>
</template>

<script>
import { fetchPowerPlant, fetchPictogramJson, fetchViewBinary, fetchViewStatuses, fetchPictogramNames, savePowerPlant, savePowerPlantScreenshot } from '../services/power-plant.service'
import { createSceneLoader } from '../services/scene-loader.service'
import { decodeView } from '../helpers/binary-scene.helper'
import { decodedToScenes } from '../helpers/scene-binary.helper'
import {
  LOAD_CONCURRENCY,
  NO_STATUS_FILL_COLOR,
  NO_STATUS_OUTLINE_PX,
} from '../data/constants'
import { base64ToBlob, convertToJpg } from '../helpers/image.helper'
import { isPointInRect, findBlockAtPoint, findTxtAtPoint } from '../helpers/geometry.helper'
import { getPartMetadata, writePartPosition, buildPartsFromSaveData } from '../helpers/metadata.helper'
import { groupEntitiesByType, buildEntitiesDrawData, entitiesBBox } from '../helpers/scene.helper'
import { findEntityAtLocalPoint, buildElementScreenGeometry } from '../helpers/picking.helper'
import { blockProgressColor } from '../helpers/progress-color.helper'
import Vue from 'vue';
import Konva from 'konva';
import VueKonva from 'vue-konva';
import {KonvaViewer} from '../../viewer-konva/utils/index'

import Uppy from '@uppy/core'
// import AwsS3Multipart from '@uppy/aws-s3-multipart'
import AwsS3 from '@uppy/aws-s3';
import store from "~/store";
import EventBus from "~/plugins/bus";
import ViewerHoverCallout from "../components/chrome/ViewerHoverCallout.vue";
import ViewerElementPopover from "../components/panels/ViewerElementPopover.vue";


Vue.use(VueKonva);

export default {
    name: "ViewerDesign",

    components: {
      ViewerHoverCallout,
      ViewerElementPopover,
    },

    props: {
      pictograms: { type: Array, default() { return [] } },
      entityId: { type: Number, required: true },
      entityType: { type: String, required: true},
      workLayer: { type: String, default: null },

      canActionsPictogram: { type: Object, default() { return {} } }, // acciones que se puede realizar sobre el pictograma por defecto ninguna
      showLayerCompleted: { type: Boolean, default: false }, // visualiza o oculta la capa de estructuras completadas
      designMode: { type: Boolean, default: false },
      pictogramType: { type: String, default: 'structures' }, // para identificar que tipo de pictogramas se debe visualizar
      isDrawing: { type: Boolean, default: false },
      selectedTool: { type: String, default: null },
      showAreas: { type: Boolean, default: false },
      drawingStrokeWidth: { type: Number, default: 0.3 },
      drawingDash: { type: Array, default() { return [] } },
      drawingStrokeColor: { type: String, default: '#1e1e1e' },
      drawingFillColor: { type: String, default: 'transparent' },
      drawingOpacity: { type: Number, default: 0.7 },
      drawingEdges: { type: String, default: 'sharp' }, // 'sharp' | 'round' → lineJoin
      rightInset: { type: Number, default: 0 }, // franja derecha tapada (panel flotante) para el callout
      // Defaults del próximo TEXTO (los fija el panel; sirven al colocar uno nuevo).
      drawingTextColor: { type: String, default: '#1e1e1e' },
      drawingTextFontSize: { type: Number, default: 16 },
      drawingTextBold: { type: Boolean, default: false },
      drawingTextItalic: { type: Boolean, default: false },
      drawingTextAlign: { type: String, default: 'left' },
      drawingTextOpacity: { type: Number, default: 1 },
      // Solo binario (sin fallback a JSON). false = ruta admin (fallback);
      // true = ruta del bot/solar-plant (futuro): si falta el .epcp, mensaje claro.
      binaryOnly: { type: Boolean, default: false }
    },

    data() {
      return {
        isLoading: false,
        progress: null,
        progressText: null,
        curProgressPhase: null,
        error: null,

        configKonva: {
          width: 800,
          height: 800,
          draggable: false,
          opacity: 1,
          pixelRatio: 2
        },


        filterStatuses: [], // estados filtrados segun se este visualizando estructuras hincados o modulos
        modifiedEntities: [], // lista de objetos que se modificaron y se mandaran para actualizar el general
        selectedObjects: [], // contiene los objetos seleccionados sobre los cuales se hande realizar acciones o acción

        powerPlant: { // objeto que hace contiene los datos del power plant
          id: 0,
          name: null
        },

        stage: null, // variable que contiene el stage/contenedor de grafica
        pics: [],
        scenes: {},

        selectedImage: null,
        selectedShapeName: '',
        keyFileUploadCurrent: null,
        selectedGroupId: null,
        hoveredGroupId: null,
        hoverCallout: null, // callout (nombre + flecha punteada) del bloque en hover; null = oculto
        selectedElement: null, // elemento con popover abierto (modo foco); null = cerrado
        focusedGroupId: null, // modo foco (vista): bloque enfocado con zoom, los demás ocultos
        lodEnabled: false, // LOD: overview por siluetas (% avance). Por defecto OFF (detalle siempre)
        lodZoomThreshold: 1.5, // detalle al superar este zoom (1 = fit). Culling lo acota al viewport, así que puede bajar
        isDragging: false,
        _isPanMode: false,

        pointsShape: [], // almacena los puntos de la forma que se va a graficar
        drawingLine: null, // referencia a la linea Konva activa durante dibujo
        previewLine: null, // referencia a la linea de preview (mouse → ultimo punto)
        vertexCircles: [], // referencias a los circulos de vertices
        snapCircle: null, // circulo indicador de snap al punto inicial
        blockIdCounter: 0, // contador unico para IDs de bloques
        txtBlockIdCounter: 0, // contador unico para IDs de textos
        selectedBlockIndex: null, // indice del bloque seleccionado para edicion
        editVertexCircles: [], // circulos de vertices editables del bloque seleccionado
        selectedTxtIndex: null, // indice del texto seleccionado para mover
        editTxtNode: null, // nodo Konva.Text temporal draggable
        editTxtTransformer: null, // Transformer para rotar/redimensionar texto
        totalImageLoad: 0,
        savingData: false,
        statusMode: 'progress', // 'progress' | 'incidents' — qué estado se pinta
        allImagesUploaded: true,

        screenshots: [],

        blocks: [], // array de objetos de block vectors
        txtBlocks: [], // array de objetos de textos
      }
    },

    computed: {
    },

    watch: {
      async pictograms(newValue, oldvalue) {
        const delItem = []

        // Crear Set para búsqueda O(1) en lugar de O(n)
        const newValueIds = new Set(newValue.map(p => p.id))
        const existingSceneIds = new Set(Object.keys(this.scenes))

        // Buscamos pictogramas que ya no existen en el nuevo array
        for (const key of existingSceneIds) {
          if (!newValueIds.has(parseInt(key)) && !newValueIds.has(key)) {
            delItem.push(key)
          }
        }

        // Eliminamos los pictogramas
        delItem.forEach(id => {
          const node = this.stage.findOne('#GroupPictogram_' + id)
          if (node) {
            node.remove()
            this.$delete(this.scenes, id)

            const indexPic = this.pics.findIndex(p => p.id == id)
            if (indexPic > -1) {
              this.pics.splice(indexPic, 1)
            }
          }
        })

        if (delItem.length) {
          this.stage.batchDraw()
        }

        // Insertamos los que no están insertados
        for (const element of newValue) {
          if (!this.scenes[element.id]) {
            await this.LoadPictogramsJson(element)
          }
        }

        this._PrepareObjects()
        this.Render(this.pictogramType)
      },

      isDrawing(newValue) {
        if (!newValue) {
          // Al desactivar dibujo, limpiar estado y restaurar cursor
          this._ClearDrawing()
          this._DeselectBlock()
          this._DeselectTxt()
          this._SetCursor('default')
        } else {
          // Al activar dibujo, desactivar seleccion de grupos, bloques y textos
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
          this._SetCursor('crosshair')
        }
      },

      selectedTool(newValue) {
        if (newValue === 'pencil') {
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
          this._SetCursor('text')
        } else {
          this._SetCursor('default')
        }
      },

      selectedGroupId() {
        this._emitSelectedCount()
      },

      selectedBlockIndex() {
        this._emitSelectedCount()
      },

      selectedTxtIndex() {
        this._emitSelectedCount()
      },

      showAreas(newValue) {
        if (newValue) {
          // Al activar areas, desactivar seleccion/hover de grupos
          this._DeselectGroup()
          this.$refs.layer.getNode().batchDraw()
        } else {
          // Al desactivar areas, limpiar bloques y textos seleccionados
          this._DeselectBlock()
          this._DeselectTxt()
        }
      },

      async pictogramType(newValue, oldValue) {
        // Al cambiar de vista se re-renderizan los grupos (todos visibles) → RESET del
        // estado de interacción: salir del foco, cerrar el popover de elemento y limpiar
        // hover/callout (si no, quedan colgados de la vista anterior).
        if (this.focusedGroupId) {
          this.focusedGroupId = null
          this._ClearFocusLabels()
          this.$emit('epc-focus-group', null)
        }
        this._CloseElementPopover()
        this._ClearHoverCallout()
        this.hoveredGroupId = null

        // Antes de cambiar de vista, guardar las posiciones actuales del canvas
        // en this.powerPlant.parts para no perderlas al renderizar otra vista
        this._SyncCurrentPositionsToMetadata(oldValue)

        this.isLoading = true
        this.$emit('epc-saving', { loading: true, text: this.$t('loading_design') })

        // Permitir que el UI muestre el loader antes de renderizar
        await new Promise(resolve => setTimeout(resolve, 20))

        try {
          // Carga bajo demanda por etapas (diseño + estados); el spinner se mantiene
          // con el mensaje de cada etapa hasta tenerlo todo.
          await this._LoadViewStaged(newValue)
        } finally {
          this.$emit('epc-saving', { loading: false, text: null })
          this.$emit('epc-isloading', false)
          this.isLoading = false
        }
      },

      async designMode(newValue, oldValue)  {
        // this._CacheGroups(newValue)
        // Pan por defecto del lienzo: ON en vista, OFF en diseño (ahí el pan va por el
        // candado y los bloques son arrastrables). Sin _isPanMode para no tapar el hover.
        if (this.stage) this.stage.draggable(!newValue)
        if (!newValue) {
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
        }

        // HARD RESET al cambiar de modo: cada modo tiene su FUENTE de datos distinta
        // (vista → binario; diseño → JSON editable, para reubicar). Salimos del estado
        // de visualización (foco + LOD), invalidamos lo cargado y recargamos la vista
        // activa desde la fuente que corresponde al nuevo modo. El re-render hace fit
        // (vuelve a la vista general limpia).
        if (this.focusedGroupId) {
          this.focusedGroupId = null
          this._ClearFocusLabels()
          this.$emit('epc-focus-group', null)
        }
        this.lodEnabled = false
        this._lodDetail = false
        this._loadedViews = new Set()
        this._jsonLoaded = false
        try {
          await this._LoadViewStaged(this.pictogramType)
        } finally {
          this.$emit('epc-saving', { loading: false, text: null })
          this.$emit('epc-isloading', false)
          this.isLoading = false
        }
      }
    },

    methods: {

      _ClearCache() {
        // Limpiar cache de todos los grupos de forma eficiente
        const layer = this.$refs.layer?.getNode()
        if (!layer) return

        layer.find('Group').forEach(group => {
          if (group.isCached()) {
            group.clearCache()
          }
        })
      },


      _ApplyCacheAsync() {
        // Aplicar cache de forma asíncrona para no bloquear el UI
        const layer = this.$refs.layer?.getNode()
        if (!layer) return

        const groups = layer.find('Group')
        let index = 0

        const cacheNextGroup = () => {
          if (index >= groups.length) {
            this.stage.batchDraw()
            return
          }

          const group = groups[index]
          if (group && !group.isCached()) {
            group.cache({ pixelRatio: 1 })
          }
          index++

          // Procesar el siguiente grupo en el próximo frame
          requestAnimationFrame(cacheNextGroup)
        }

        requestAnimationFrame(cacheNextGroup)
      },

      _CacheGroups(apply_cache) {
        if (!apply_cache) {
          this._ClearCache()
          return
        }

        // Solo aplicar cache si hay pocos grupos (evita congelar con muchos)
        if (this.pics.length <= 10) {
          this._ApplyCacheAsync()
        }
      },

      async Load() {
        this.isLoading = true
        this.$emit('epc-saving', { loading: true, text: this.$t('loading_design') })
        this.error = null

        let partsPark = []

        try {
          const response = await fetchPowerPlant(this.entityId, this.entityType)

          if (response.data && response.data.power_plant) {
            this.powerPlant = response.data.power_plant;

            // Nombres para la cabecera del visor (nombre de planta + proyecto).
            this.$emit('epc-powerplant-info', {
              powerPlantName: this.powerPlant.name || null,
              projectName: this.powerPlant.project ? this.powerPlant.project.name : null,
              projectId: this.powerPlant.project ? this.powerPlant.project.id : null,
            })

            response.data.power_plant.parts.forEach(part => {
              partsPark.push(part.pictogram_id)
            });

            if (response.data.power_plant.metadata != null) {
              response.data.power_plant.metadata.areas.texts.forEach(txt => {
                txt.draggable = true
                this.txtBlocks.push(txt);
              })

              response.data.power_plant.metadata.areas.blocks.forEach(block => {
                block.draggable = true
                this.blocks.push(block);
                if (block.id && block.id >= this._blockIdCounter) {
                  this._blockIdCounter = block.id
                }
              })
            }

            // Carga BAJO DEMANDA por ETAPAS: solo la vista activa (binario si existe,
            // si no JSON) + estados. Las demás vistas se cargan al cambiar (watcher).
            this._loadedViews = new Set()
            this._jsonLoaded = false
            await this._LoadViewStaged(this.pictogramType)
          }

          this.$emit('epc-loaded', partsPark);
        } catch (error) {
          console.warn(error);
        } finally {
          // Fin de TODAS las etapas → recién aquí se apaga el spinner.
          this.$emit('epc-saving', { loading: false, text: null })
          this.$emit('epc-isloading', false)
          this.isLoading = false
          this.progressText = null
          this.progress = null
          this.curProgressPhase = null
        }
      },

      /**
       * Intenta cargar UNA vista desde su binario .epcp (mismo origen, vía API).
       * Si existe: decodifica y FUSIONA en this.scenes (sin pisar otras vistas) y
       * devuelve true. Si no existe (404) o falla: devuelve false para que el caller
       * decida (fallback JSON o mensaje).
       */
      async _LoadViewFromBinary(view) {
        if (!this.powerPlant || !this.powerPlant.id) return false
        try {
          const response = await fetchViewBinary(this.powerPlant.id, view)
          const decoded = decodeView(response.data) // response.data = ArrayBuffer
          const scenesByPic = decodedToScenes(decoded, view)

          Object.keys(scenesByPic).forEach(picId => {
            if (this.scenes[picId]) {
              this.$set(this.scenes[picId].entitiesByType, view, scenesByPic[picId].entitiesByType[view])
            } else {
              this.$set(this.scenes, picId, scenesByPic[picId])
            }
          })
          return true
        } catch (error) {
          // 404 = parque sin binario generado; cualquier otro error → también fallback.
          return false
        }
      },

      /**
       * Trae el estado+color en vivo (Mongo) de una vista y lo aplica a las entidades
       * ya cargadas desde el binario (que vienen con status:null → gris). Al terminar
       * repinta SOLO si seguimos en esa vista. No se await: la geometría ya se mostró.
       */
      async _ApplyViewStatuses(view) {
        if (!this.powerPlant || !this.powerPlant.id) return
        try {
          const { data } = await fetchViewStatuses(this.powerPlant.id, view)
          if (!data || !data.statuses) return

          // Guardamos los datos de la vista para poder alternar progreso/incidencias
          // sin volver a pedirlos.
          if (!this._viewStatusData) this._viewStatusData = {}
          this._viewStatusData[view] = {
            statuses: data.statuses || {},
            incidents: data.incidents || {},
            colors: data.colors || {},
            completionStatusIds: data.completionStatusIds || [],
          }

          this._ApplyStatusMode(view)
        } catch (error) {
          // Sin estados (o error) → la vista se queda en gris, sin romper nada.
        }
      },

      /**
       * Aplica a las entidades de la vista el mapa del modo activo (progreso o
       * incidencias) y repinta. Las entidades sin dato en ese modo quedan en gris.
       */
      _ApplyStatusMode(view) {
        const data = this._viewStatusData && this._viewStatusData[view]
        if (!data) return

        const map = this.statusMode === 'incidents' ? data.incidents : data.statuses
        const colors = data.colors || {}

        let changed = false
        Object.keys(this.scenes).forEach(picId => {
          const entities = this.scenes[picId] && this.scenes[picId].entitiesByType
            ? this.scenes[picId].entitiesByType[view]
            : null
          if (!entities) return
          for (const e of entities) {
            const statusId = map ? map[picId + ':' + e.id] : undefined
            if (statusId != null) {
              e.status = statusId
              e.fill = colors[String(statusId)] || e.fill
            } else {
              e.status = null // sin dato en este modo → gris
            }
            changed = true
          }
        })

        // Render (consciente del foco) lee this.scenes directamente. Solo si seguimos
        // en esa vista; recolorea las siluetas (overview) o el detalle (foco).
        if (changed && this.pictogramType === view) {
          this.Render(view)
        }
      },

      // Método público: alterna entre 'progress' e 'incidents' y repinta la vista activa.
      SetStatusMode(mode) {
        this.statusMode = mode
        this._ApplyStatusMode(this.pictogramType)
      },

      // Método público: activa/desactiva el LOD y repinta (preservando el zoom actual).
      SetLodEnabled(enabled) {
        this.lodEnabled = enabled
        this._lodDetail = enabled ? this._ShouldLodDetail() : false
        this.Render(this.pictogramType, { skipFit: true })
      },

      /**
       * Asegura que los datos de `view` estén en this.scenes (carga BAJO DEMANDA).
       * 1) intenta el binario; 2) si binaryOnly → mensaje claro (ruta del bot, futuro);
       * 3) si no → pool JSON actual (que trae las 3 vistas de una).
       * TODO (Fase 5): invalidar por geomVersion (staleness) antes de usar el binario.
       */
      async _EnsureView(view) {
        if (!this._loadedViews) this._loadedViews = new Set()
        if (this._loadedViews.has(view)) return 'cached'

        // MODO DISEÑO: se edita/reubica sobre los pictogramas JSON (editables, con toda
        // su info). Es la ÚNICA ruta que carga JSON. El pool llena las 3 vistas; el
        // estado ya viene incrustado en el JSON (no hay etapa de estados separada).
        if (this.designMode) {
          this.$emit('epc-binary-processing', false)
          if (!this._jsonLoaded) {
            await this._LoadPictogramsPool(this.powerPlant.parts)
            this._jsonLoaded = true
            ;['structures', 'pilings', 'modules'].forEach(v => this._loadedViews.add(v))
          }
          this._loadedViews.add(view)
          this._ClearBinaryMissingMessage()
          this.$emit('epc-binary-missing', false)
          return 'json'
        }

        // MODO VISTA: SIEMPRE desde el binario (rápido). NO hay fallback a JSON. Si el
        // binario de esta vista no existe → mensaje en el lienzo (hay que entrar en
        // diseño —que carga JSON— o esperar a que se genere el binario).
        this.$emit('epc-binary-processing', this._IsBinaryStale())

        if (await this._LoadViewFromBinary(view)) {
          this._loadedViews.add(view)
          this._ClearBinaryMissingMessage()
          this.$emit('epc-binary-missing', false)
          // El binario viene SIN estado (gris); el estado/color en vivo de Mongo lo
          // trae el orquestador (_LoadViewStaged) como etapa aparte (await) para que el
          // spinner siga presente hasta tenerlo todo.
          return 'binary'
        }

        // No existe el binario de esta vista → mensaje (en el lienzo, sale en capturas).
        this._ShowBinaryMissingMessage()
        this.$emit('epc-binary-missing', true)
        return 'missing'
      },

      /**
       * Orquesta la carga COMPLETA de una vista por ETAPAS, manteniendo el spinner con
       * un mensaje por etapa hasta que no quede nada por cargar:
       *   1) "Cargando diseño"  → geometría (binario o, si no, pool JSON).
       *   2) "Cargando estados" → SOLO si vino del binario (gris); el estado/color vive
       *      en Mongo y se pide aparte. El pool JSON ya trae el estado incrustado.
       * El apagado del spinner lo hace el caller (Load / watcher) en su finally.
       */
      async _LoadViewStaged(view) {
        this.$emit('epc-saving', { loading: true, text: this.$t('loading_design') })
        const source = await this._EnsureView(view)
        this._PrepareObjects()
        await this.Render(view)

        if (source === 'binary') {
          this.$emit('epc-saving', { loading: true, text: this.$t('loading_statuses') })
          await this._ApplyViewStatuses(view)
        }
      },

      // Stale = hay un guardado de DISEÑO (metadata.design_updated_at) posterior a la
      // última generación del binario (metadata.binary.built_at). Ambos a nivel PARQUE.
      _IsBinaryStale() {
        const m = (this.powerPlant && this.powerPlant.metadata) || {}
        const design = m.design_updated_at ? Date.parse(m.design_updated_at) : 0
        const built = (m.binary && m.binary.built_at) ? Date.parse(m.binary.built_at) : 0
        return design > 0 && design > built
      },

      // Aviso (Pusher) de binario regenerado. Si es ESTE parque y estamos en
      // visualización, marcamos built_at al día (quita el stale), invalidamos las vistas
      // cargadas y recargamos la activa desde el binario fresco (swap atómico).
      async _OnBinaryReady(e) {
        if (!this.powerPlant || !e || String(e.entity_id) !== String(this.powerPlant.id)) return
        if (this.designMode) return // en diseño se trabaja por partes; no recargamos

        const m = this.powerPlant.metadata || {}
        m.binary = Object.assign({}, m.binary, { built_at: e.built_at })
        this.$set(this.powerPlant, 'metadata', m)
        this.$emit('epc-binary-processing', false)

        this._loadedViews = new Set()
        this._jsonLoaded = false
        try {
          await this._LoadViewStaged(this.pictogramType)
        } finally {
          this.$emit('epc-saving', { loading: false, text: null })
          this.$emit('epc-isloading', false)
          this.isLoading = false
        }
      },

      // Mensaje "binario ausente" como texto Konva en el lienzo (sale en la captura).
      _ShowBinaryMissingMessage() {
        const layer = this.$refs.layer && this.$refs.layer.getNode()
        if (!layer) return
        this._ClearBinaryMissingMessage()
        layer.add(new Konva.Text({
          name: 'binaryMissingText',
          text: this.$t('power_plant_binary_missing'),
          x: 0,
          y: 0,
          width: 500, // envuelve el texto (mejor en la captura que una línea larga)
          fontSize: 24,
          fontStyle: 'bold',
          fill: '#868e96',
          align: 'center',
        }))
        layer.batchDraw()
      },

      _ClearBinaryMissingMessage() {
        const layer = this.$refs.layer && this.$refs.layer.getNode()
        if (layer) layer.find('.binaryMissingText').forEach(n => n.destroy())
      },

      /**
       * Pool de descarga con concurrencia limitada. Lanza N = LOAD_CONCURRENCY
       * "workers" que consumen una cola compartida de `parts`; en cada momento hay
       * como máximo N descargas en vuelo, sea cual sea el número de pictogramas.
       * La DESCARGA (lenta, es esperar al servidor) corre en paralelo; el PROCESO
       * que toca el engine compartido es SÍNCRONO dentro del worker (sin await
       * en medio), así no se pisan el estado entre pictogramas.
       */
      async _LoadPictogramsPool(parts) {
        // El spinner lo controla el orquestador (_LoadViewStaged); aquí solo marcamos
        // el flag local y NO emitimos epc-isloading para no apagarlo a mitad de etapa.
        this.isLoading = true
        this.error = null

        // La orquestación del pool vive ahora en el servicio `scene-loader` (núcleo
        // estable, sin motor ni Vue); aquí solo inyectamos CÓMO se descarga y procesa
        // cada parte. Comportamiento idéntico al anterior: descarga en paralelo
        // (concurrencia LOAD_CONCURRENCY), proceso síncrono sobre el motor compartido.
        // Es el punto donde el loader binario se enchufará en fases siguientes.
        const loader = createSceneLoader({
          concurrency: LOAD_CONCURRENCY,
          download: (part) => this._DownloadDesign(part.pictogram),
          process: (part, design) => this._ProcessPictogramScene(part.pictogram, design),
        })

        try {
          await loader.loadParts((parts || []).filter(p => p && p.pictogram))
        } finally {
          // No apagamos el spinner aquí: lo hace el orquestador tras TODAS las etapas.
          this.isLoading = false
          this.progressText = null
          this.progress = null
          this.curProgressPhase = null
        }
      },

      /**
       * Descarga (solo red) el JSON del pictograma. NO toca el engine
       * compartido, por eso puede correr en paralelo. Devuelve el design parseado
       * o null si falla.
       */
      async _DownloadDesign(pic) {
        try {
          const { data: design } = await fetchPictogramJson(pic.id)
          return design
        } catch (error) {
          console.warn('Error descargando pictograma ' + (pic && pic.id), error)
          this.error = error.toString()
          return null
        }
      },

      /**
       * Proceso SÍNCRONO: vuelca el design en el engine, lo transforma a
       * entidades y las guarda en scenes[pic.id] agrupadas por tipo. DEBE ser
       * síncrono (sin await) para no intercalarse con otro pictograma sobre el
       * engine compartido.
       */
      _ProcessPictogramScene(pic, design) {
        this.engine.SetDataPictogram(design)
        const scene = this.engine.GetEntities(pic.layers)

        // Pre-procesar entidades por tipo (O(n) una sola vez). Solo guardamos labels y
        // entitiesByType, descartamos entities/backgrounds/completed para liberar memoria
        // (no se usan después del pre-filtrado).
        this.$set(this.scenes, pic.id, {
          labels: scene.labels,
          entitiesByType: groupEntitiesByType(scene.entities)
        })

        // Liberar datos crudos del viewer que ya no se necesitan
        this.engine.entities = []
        this.engine.labels = []

        return scene
      },

      // Carga de UN pictograma individual (p. ej. al agregarse uno nuevo desde el
      // watcher `pictograms`). Reusa la descarga + proceso del pool.
      async LoadPictogramsJson(pic=null) {
        if (!pic) return

        this.isLoading = true
        this.$emit('epc-isloading', true)
        this.error = null

        try {
          const design = await this._DownloadDesign(pic)
          if (design) this._ProcessPictogramScene(pic, design)
        } catch (error) {
            console.warn(error)
            this.error = String(error)
        } finally {
            this.$emit('epc-isloading', false)
            this.isLoading = false
            this.progressText = null
            this.progress = null
            this.curProgressPhase = null
        }
      },

      _PrepareObjects() {
        Object.entries(this.scenes).forEach(([key, value]) => {
          if ( ! this.pics.find(p => p.id == key) ) {
            this.pics.push({
              id: key,
              config: {
                id: 'GroupPictogram_' + key,
                name: 'groupPictogram',
                draggable: false,
                x: 0,
                y: 0,
                rotation: 0
              },
              labels: value.labels,
              entities: []
            })
          }
        });
      },

      _GetMetadata(pictogram_id, type) {
        return getPartMetadata(this.powerPlant.parts, pictogram_id, type)
      },

      _SyncCurrentPositionsToMetadata(type) {
        // Recorre los grupos del canvas y actualiza this.powerPlant.parts
        // con las posiciones actuales, para que al cambiar de vista no se pierdan
        const layer = this.$refs.layer?.getNode()
        if (!layer || !this.powerPlant.parts) return

        layer.find('Group').forEach(group => {
          const pictogramId = parseInt(group.id().replace('GroupPictogram_', ''))
          const part = this.powerPlant.parts.find(p => p.pictogram_id == pictogramId)
          if (!part) return

          writePartPosition(part, type, {
            x: group.x(),
            y: group.y(),
            rotation: group.rotation()
          })
        })
      },

      _BuildPartsFromSaveData(dataPictograms) {
        // Construye o actualiza this.powerPlant.parts con los datos enviados al backend
        // (el backend no devuelve los parts en la respuesta).
        this.powerPlant.parts = buildPartsFromSaveData(this.powerPlant.parts, dataPictograms)
      },

      // Construye UNA sola Konva.Shape (sceneFunc) que pinta TODAS las entidades del
      // tipo activo de un pictograma, en vez de crear un Konva.Rect por entidad.
      // Los rects eran `listening:false` y la selección/hover trabaja a nivel de GRUPO
      // (via getClientRect), así que no se pierde interactividad. Esto colapsa decenas
      // de miles de nodos Konva a ~1 por pictograma → evita el freeze al cambiar a la
      // vista `modules` (la más densa: cada estructura tiene muchos paneles).
      // Silueta de un bloque para el overview (LOD): UN rect en el bbox local de las
      // entidades, relleno con el color del % de avance. Mismo bbox que el detalle,
      // así hover/getClientRect/FitToScreen quedan consistentes.
      _CreateBlockSilhouette(entities, color) {
        const bbox = entitiesBBox(entities)
        if (!bbox) return null

        return new Konva.Rect({
          name: 'blockSilhouette',
          x: bbox.minX,
          y: bbox.minY,
          width: bbox.maxX - bbox.minX,
          height: bbox.maxY - bbox.minY,
          fill: color,
          listening: false,
        })
      },

      // Color de la silueta de un bloque según el modo:
      //  - progreso:    % de entidades COMPLETADAS (is_completion)   → rampa gris→verde
      //  - incidencias: % de entidades con INCIDENCIA                → rampa gris→rojo
      _BlockProgressColor(picId, view) {
        const entities = this.scenes[picId] && this.scenes[picId].entitiesByType
          ? this.scenes[picId].entitiesByType[view]
          : null
        const data = this._viewStatusData && this._viewStatusData[view]
        return blockProgressColor(entities, data, {
          picId,
          statusMode: this.statusMode,
          noStatusColor: NO_STATUS_FILL_COLOR,
        })
      },

      _CreateEntitiesShape(entities) {
        // El armado de bbox + buckets (por color/opacidad/contorno) es puro → helper. Aquí
        // solo queda el motor: la Konva.Shape y su sceneFunc que pinta esos buckets.
        const drawData = buildEntitiesDrawData(entities)
        if (!drawData) return null
        const { minX, minY, maxX, maxY, buckets: drawBuckets } = drawData

        return new Konva.Shape({
          name: 'entitiesShape',
          x: minX,
          y: minY,
          width: maxX - minX,
          height: maxY - minY,
          listening: false,
          sceneFunc: (ctx, shape) => {
            // Grosor en coords locales que se ve ~constante en pantalla: dividimos
            // el objetivo en px por la escala absoluta (el zoom vive en el stage).
            const scale = shape.getAbsoluteScale().x || 1
            const lineWidth = NO_STATUS_OUTLINE_PX / scale
            for (const b of drawBuckets) {
              ctx.globalAlpha = b.opacity
              const r = b.rects
              if (b.stroke) {
                ctx.strokeStyle = b.fill
                ctx.lineWidth = lineWidth
                for (let i = 0; i < r.length; i += 4) {
                  ctx.strokeRect(r[i], r[i + 1], r[i + 2], r[i + 3])
                }
              } else {
                ctx.fillStyle = b.fill
                for (let i = 0; i < r.length; i += 4) {
                  ctx.fillRect(r[i], r[i + 1], r[i + 2], r[i + 3])
                }
              }
            }
            ctx.globalAlpha = 1
          }
        })
      },

      async Render(type, { skipFit = false } = {}) {
        const layer = this.$refs.layer.getNode()

        const existingGroupIds = new Set()

        // Recorrer grupos existentes para reutilizar o eliminar
        layer.find('Group').forEach(group => {
          existingGroupIds.add(group.id())
        })

        // Set de ids que deberían existir
        const expectedGroupIds = new Set(
          this.pics.filter(p => this.scenes[p.id]).map(p => 'GroupPictogram_' + p.id)
        )

        // Eliminar grupos que ya no deben estar
        layer.find('Group').forEach(group => {
          if (!expectedGroupIds.has(group.id())) {
            group.destroy()
          }
        })

        for (const pic of this.pics) {
          const sceneData = this.scenes[pic.id]
          if (!sceneData) continue

          const groupId = 'GroupPictogram_' + pic.id
          const metadata = this._GetMetadata(pic.id, type)
          let group = layer.findOne('#' + groupId)

          if (group) {
            // Grupo existe: actualizar posición y solo reemplazar entidades (Rect)
            group.setAttrs({
              draggable: this.designMode && !this._navigationMode,
              x: metadata?.x || 0,
              y: metadata?.y || 0,
              rotation: metadata?.rotation || 0
            })

            // Eliminar la shape de entidades/silueta anterior, conservar los Text (labels)
            group.find('.entitiesShape').forEach(shape => shape.destroy())
            group.find('.blockSilhouette').forEach(shape => shape.destroy())
          } else {
            // Grupo nuevo: crear con labels
            group = new Konva.Group({
              id: groupId,
              name: 'groupPictogram',
              draggable: this.designMode && !this._navigationMode,
              x: metadata?.x || 0,
              y: metadata?.y || 0,
              rotation: metadata?.rotation || 0
            })

            if (sceneData.labels) {
              for (const labelConfig of sceneData.labels) {
                group.add(new Konva.Text(labelConfig))
              }
            }

            layer.add(group)
          }

          // LOD OPCIONAL (por defecto OFF → detalle siempre, como antes). Con LOD, en
          // overview cada bloque es una SILUETA (1 rect, color por % de avance) y solo
          // el bloque ENFOCADO se pinta al DETALLE. En foco (con o sin LOD) solo el
          // enfocado es visible.
          // Base del LOD: detalle si LOD off o es el bloque enfocado; si no, silueta.
          // El culling por viewport (detalle solo en los bloques VISIBLES al acercar)
          // lo aplica _ApplyLod tras el fit.
          const isFocusedBlock = this.focusedGroupId === groupId
          this._BuildBlockShape(group, pic.id, type, !this.lodEnabled || isFocusedBlock)

          group.visible(!this.focusedGroupId || isFocusedBlock)
        }

        // Renderizar una sola vez al final
        layer.batchDraw()

        // Centrar contenido (salvo en re-render por LOD, que preserva el zoom actual).
        await this.$nextTick()
        if (!skipFit) {
          this.engine.FitToScreen()
          // El fit del OVERVIEW (no foco) define la escala base del 100%.
          if (!this.focusedGroupId) this._fitScale = this.stage.scaleX()
        }

        // Culling por viewport: si el zoom está por encima del umbral, sube a detalle
        // solo los bloques visibles (tras el fit, para que getClientRect sea correcto).
        this.$nextTick(() => this._ApplyLod())

        // NOTA: Render ya NO apaga el spinner. El ciclo del loader (encenderlo, el
        // mensaje por etapa y apagarlo al terminar TODO) lo controlan los orquestadores
        // (Load / watcher pictogramType) vía _LoadViewStaged + su finally, para que el
        // spinner siga visible mientras se cargan los estados tras el render de la geometría.
      },

      GetLayers() {
        return this.engine.GetLayers()
      },

      EnableDraggable(enable) {
        this.engine.EnableDraggable(enable)
        this._SetCursor(enable ? 'grab' : 'default')
        this._isPanMode = enable
      },

      // Candado navegación/edición: en navegación se activa el pan y los grupos de
      // pictograma dejan de ser arrastrables (solo se puede ver/desplazar, no editar).
      SetNavigationMode(nav) {
        this._navigationMode = nav
        this.EnableDraggable(nav)

        const layer = this.$refs.layer && this.$refs.layer.getNode()
        if (layer) {
          layer.find('.groupPictogram').forEach(g => {
            g.draggable(nav ? false : this.designMode)
          })
        }
      },

      async SaveScreenshot(imgDataUrl) {
        try {
          this.$emit('epc-saving', { loading: true, text: 'Guardando captura' })
          await this.$nextTick()

          const baseName = this.pictogramType + (this.showAreas ? '_with_area' : '')
          const base64Data = imgDataUrl.replace('data:image/png;base64,', '')
          const pngBlob = base64ToBlob(base64Data, 'image/png')
          const jpgBlob = await convertToJpg(imgDataUrl, 0.9)

          const screenshots = [
            { name: baseName + '.png', src: pngBlob },
            { name: baseName + '_a4.jpg', src: jpgBlob }
          ]

          this.$emit('epc-saving', { loading: true, text: 'Subiendo capturas' })

          const uploadResults = []
          for (const item of screenshots) {
            uploadResults.push(await this._submitResource(item))
          }

          const arrAwsResponse = uploadResults.filter(r => r !== null)
          if (arrAwsResponse.length !== screenshots.length) {
            this.$notify.error('error_saving')
            return false
          }

          this.$emit('epc-saving', { loading: true, text: 'Guardando datos' })

          const form = new FormData()
          form.append('update_only_screenshot', 1)
          form.append('aws_images', JSON.stringify(arrAwsResponse))

          const response = await savePowerPlantScreenshot(this.powerPlant.id, form)
          if (response.data && response.data.success) {
            this.$notify.success('success_editing')
            return true
          } else {
            this.$notify.error('error_saving')
            return false
          }
        } catch (error) {
          console.error('Error en SaveScreenshot():', error)
          this.$notify.error('error_saving')
          return false
        } finally {
          this.$emit('epc-saving', { loading: false, text: null })
        }
      },

      /**
       * Captura para el BOTÓN manual (no para el thumbnail de Save()). Gateada por
       * headless para NO romper el bot: el bot (HeadlessChrome) sigue capturando el
       * PARQUE COMPLETO (engine.Screenshot, bbox de todo el contenido). Un usuario
       * manual captura solo el VIEWPORT visible (respeta zoom/pan) recortando al
       * tamaño del contenedor. Devuelve un dataURL PNG igual que engine.Screenshot.
       */
      CaptureScreenshot({ includeOverlays = false } = {}) {
        const isHeadless = typeof navigator !== 'undefined' && /HeadlessChrome/.test(navigator.userAgent)
        if (isHeadless) {
          return this.engine.Screenshot({ includeOverlays })
        }

        const container = this.$refs.canvasContainer
        const ratio = (typeof window !== 'undefined' && window.devicePixelRatio) ? window.devicePixelRatio : 1
        return this.stage.toDataURL({
          mimeType: 'image/png',
          quality: 1,
          pixelRatio: Math.min(6, Math.max(1, ratio)),
          x: 0,
          y: 0,
          width: container.offsetWidth,
          height: container.offsetHeight,
        })
      },

      async Save() {
        try {
          // Limpiar selección y hover antes de capturar screenshot
          // para que no se incluyan en la imagen ni queden en estado inconsistente
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
          this.$refs.layer.getNode().batchDraw()

          this.$emit('epc-saving', { loading: true, text: 'Generando captura de ' + this.$t(this.pictogramType) })
          await this.$nextTick();
          // Esperamos dos frames reales de pintura para que el browser renderice el loader
          // antes de ejecutar el toDataURL() síncrono que bloquea el hilo principal
          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)))

          this.savingData = true

          let img = this.engine.Screenshot({ includeOverlays: this.showAreas })
          // CropImage: deshabilitado porque CalculateBoundingBox ya recorta al contenido con padding,
          // el escaneo pixel-por-pixel de CropImage es redundante y costoso en imágenes grandes
          // img = await this.engine.CropImage(img);
          img = await this.engine.GetBase64Image(img, true)

          const baseName = this.pictogramType + (this.showAreas ? '_with_area' : '')
          const base64Data = img.replace('data:image/png;base64,', '')
          const pngBlob = base64ToBlob(base64Data, 'image/png')
          const jpgBlob = await convertToJpg(img, 0.9)

          const screenshots = [
            { name: baseName + '.png', src: pngBlob },
            { name: baseName + '_a4.jpg', src: jpgBlob }
          ]

          // Subir screenshots en paralelo
          this.$emit('epc-saving', { loading: true, text: 'Guardando capturas' })

          const uploadResults = []
          for (const item of screenshots) {
            uploadResults.push(await this._submitResource(item))
          }

          // Validar que todas las subidas fueron exitosas
          const arrAwsResponse = uploadResults.filter(r => r !== null)
          if (arrAwsResponse.length !== screenshots.length) {
            this.$notify.error('error_saving')
            return
          }

          // Guardar datos solo si los uploads fueron exitosos
          this.$emit('epc-saving', { loading: true, text: 'Guardando datos' })
          this._CacheGroups(true)

          await this._SaveDataPowerPlant(arrAwsResponse);

          // Guardado OK → avisamos para salir de diseño y volver a vista (binario). El
          // binario quedará stale (regen en background) → se verá con el chip "procesando".
          this.$emit('epc-saved')

        } catch (error) {
          console.error('Error en Save():', error)
          this.$notify.error('error_saving')
        } finally {
          this.savingData = false
          this.$emit('epc-saving', { loading: false, text: null })
        }
      },

      async _submitResource(resource) {
        try {
          const blob = resource.src;
          const file = new File([blob], resource.name, { type: blob.type })
          const result = await this._store(file)

          if (result.successful.length > 0) {
            const response = result.successful[0].response
            return {
              key: response.body.key,
              name: resource.name,
              content_type: blob.type,
            }
          }

          if (result.failed.length > 0) {
            result.failed.forEach((f) => console.error('Upload failed:', f.error))
          }
          return null
        } catch (error) {
          console.error('Error uploading resource:', error)
          return null
        }
      },

      async _store(file) {
        // Limpiar archivo previo de Uppy antes de agregar uno nuevo
        if (this.keyFileUploadCurrent) {
          try { this.uppy.removeFile(this.keyFileUploadCurrent) } catch (e) { /* ya no existe */ }
          this.keyFileUploadCurrent = null
        }

        this.keyFileUploadCurrent = this.uppy.addFile({
          name: file.name,
          type: file.type,
          data: file,
          source: 'Local',
          isRemote: false,
        });

        return this.uppy.upload()
      },

      async _SaveDataPowerPlant(awsResponseImages) {
        // 1. contabilizar primero total de entidades por typo y estado
        let dataPictograms = []

        let stage = this.stage

        this.$refs.layer.getNode().find('Group').forEach(group => {

          let imgData = {
            id: group.id().replace('GroupPictogram_', ''),
            metadata: { }
          }

          if (this.pictogramType === 'structures') {
            imgData.metadata['default'] = {
              x: group.x(),
              y: group.y(),
              // width: node.width(),
              // height: node.height(),
              rotation: group.rotation()
            }
          }

          imgData.metadata[this.pictogramType] = {
            x: group.x(),
            y: group.y(),
            // width: node.width(),
            // height: node.height(),
            rotation: group.rotation()
          }

          dataPictograms.push(imgData)
        });

        // 3. preparar para mandar al backend
        let form = new FormData();

        form.append('name', 'power plant project ' + this.entityId)
        form.append('pictograms', JSON.stringify(dataPictograms))
        form.append('aws_images', JSON.stringify(awsResponseImages))

        let areas = { blocks: [], texts: [] }

        this.blocks.forEach(block => {
          areas.blocks.push({
            id: block.id,
            name: block.name,
            points: block.points,
            fill: block.fill,
            closed: block.closed,
            opacity: block.opacity,
            stroke: block.stroke,
            strokeWidth: block.strokeWidth,
            dash: block.dash,
            lineCap: block.lineCap,
            lineJoin: block.lineJoin,
            x: block.x,
            y: block.y
          })
        })

        this.txtBlocks.forEach(txt => {
          areas.texts.push({
            id: txt.id,
            name: txt.name,
            fontSize: txt.fontSize,
            fontStyle: txt.fontStyle,
            fill: txt.fill,
            align: txt.align,
            opacity: txt.opacity,
            rotation: txt.rotation,
            width: txt.width,
            text: txt.text,
            x: txt.x,
            y: txt.y
          })
        })

        form.append('metadata', JSON.stringify({ areas: areas }))

        // Enviamos el form (crea si no hay powerPlant.id, edita si ya existe)
        return await savePowerPlant(this.entityId, form, this.powerPlant.id)
          .then((response) => {
            let data = response.data

            if (data && data.success) {
              // Si es la primera vez (create), el backend devuelve el id del power plant
              // para que las siguientes operaciones sean edits y no creen duplicados
              if (data.power_plant_id) {
                this.powerPlant.id = data.power_plant_id
              }

              // Construir/actualizar this.powerPlant.parts con las posiciones actuales
              // El backend no devuelve los parts en la respuesta, así que los mantenemos localmente
              this._BuildPartsFromSaveData(dataPictograms)
              this.$notify.success('success_editing')
              console.log('%cEPC-TACKER: '+ '%c power plant guardado correctamente.', 'background: #5577BB; color: #fff', 'color: #000')

              return true;
            } else if(data && data.msg){
              this.$notify.error('no_access_permissions')
            } else {
              this.$notify.error('error_saving')
            }

            return false;
          })
          .catch(error => {
            // Manejar errores aquí
            if (error.response) {
              // La solicitud fue hecha y el servidor respondió con un estado de error
              this.$notify.error(error.response.data.message)
              // console.log('Error de respuesta:', error.response.status, error.response.data);
              console.error('%cEPC-TACKER: '+ '%c Error de respuesta:', 'background: #5577BB; color: #fff', 'color: #000', error.response.status, error.response.data)
            } else if (error.request) {
              // La solicitud se realizó pero no se recibió respuesta del servidor
              this.$notify.error('No se recibió respuesta del servidor (E500)')
              console.error('%cEPC-TACKER: '+ '%c No se recibió respuesta del servidor', 'background: #5577BB; color: #fff', 'color: #000')
            } else {
              // Ocurrió un error antes de la solicitud, como una configuración incorrecta de Axios
              this.$notify.error('Error de configuración')
              console.error('%cEPC-TACKER: '+ '%c Error de configuración:', 'background: #5577BB; color: #fff', 'color: #000', error.message)
            }

            return false;
          })
      },

      _OnProgress(phase, size, totalSize) {
          if (phase !== this.curProgressPhase) {
              switch(phase) {
              case "font":
                  this.progressText = "Fetching fonts..."
                  break
              case "fetch":
                  this.progressText = "Fetching file..."
                  break
              case "parse":
                  this.progressText = "Parsing file..."
                  break
              case "prepare":
                  this.progressText = "Preparing rendering data..."
                  break
              }
              this.curProgressPhase = phase
          }
          if (totalSize === null) {
              this.progress = -1
          } else {
              this.progress = size / totalSize
          }
      },

      // ========== DIBUJO DE VECTORES ==========

      _GetMousePointTransformed() {
        const pos = this.stage.getPointerPosition()
        if (!pos) return null
        const transform = this.stage.getAbsoluteTransform().copy()
        transform.invert()
        return transform.point(pos)
      },

      _GetSnapDistance() {
        const zoomLevel = this.engine.GetZoomLavel() || 1
        return 10 / zoomLevel
      },

      _IsNearFirstPoint(point) {
        if (this.pointsShape.length < 3) return false
        const first = this.pointsShape[0]
        const dx = point.x - first.x
        const dy = point.y - first.y
        return Math.sqrt(dx * dx + dy * dy) < this._GetSnapDistance()
      },

      handleDrawingClick(e) {
        if (!this.isDrawing) return

        e.evt.preventDefault()
        const point = this._GetMousePointTransformed()
        if (!point) return

        const vectorLayer = this.$refs.refVectors.getNode()

        // Si esta cerca del primer punto y hay al menos 3 puntos, cerrar poligono
        if (this._IsNearFirstPoint(point)) {
          this._ClosePolygon()
          return
        }

        // Agregar punto
        this.pointsShape.push({ x: point.x, y: point.y })

        // Actualizar o crear la linea principal
        this._UpdateDrawingLine()

        // Agregar circulo de vertice
        this._AddVertexCircle(point)

        vectorLayer.batchDraw()
      },

      _UpdateDrawingLine() {
        const vectorLayer = this.$refs.refVectors.getNode()
        const flatPoints = this.pointsShape.flatMap(p => [p.x, p.y])

        if (!this.drawingLine) {
          const zoomLevel = this.engine.GetZoomLavel() || 1
          this.drawingLine = new Konva.Line({
            name: 'drawingLine',
            points: flatPoints,
            stroke: '#2980b9',
            strokeWidth: Math.max(0.3, 1 / zoomLevel),
            lineCap: 'round',
            lineJoin: 'round',
            listening: false,
          })
          vectorLayer.add(this.drawingLine)
          this.drawingLine.moveToBottom()
        } else {
          this.drawingLine.points(flatPoints)
        }
      },

      _AddVertexCircle(point) {
        const vectorLayer = this.$refs.refVectors.getNode()
        const isFirst = this.vertexCircles.length === 0
        const radius = this._GetVertexRadius()
        const strokeWidth = Math.max(0.5, 1.5 / (this.engine.GetZoomLavel() || 1))

        const circle = new Konva.Circle({
          name: isFirst ? 'vertexFirst' : 'vertex',
          x: point.x,
          y: point.y,
          radius: radius,
          fill: isFirst ? '#e74c3c' : 'white',
          stroke: isFirst ? '#c0392b' : '#2980b9',
          strokeWidth: strokeWidth,
          listening: false,
        })

        vectorLayer.add(circle)
        this.vertexCircles.push(circle)
      },

      handleDrawingMouseMove(e) {
        if (!this.isDrawing || this.pointsShape.length === 0) return

        const point = this._GetMousePointTransformed()
        if (!point) return

        const vectorLayer = this.$refs.refVectors.getNode()
        const lastPoint = this.pointsShape[this.pointsShape.length - 1]

        // Actualizar o crear linea de preview
        if (!this.previewLine) {
          const zoomLevel = this.engine.GetZoomLavel() || 1
          this.previewLine = new Konva.Line({
            name: 'previewLine',
            points: [lastPoint.x, lastPoint.y, point.x, point.y],
            stroke: '#2980b9',
            strokeWidth: Math.max(0.3, 0.8 / zoomLevel),
            dash: [6 / zoomLevel, 3 / zoomLevel],
            listening: false,
          })
          vectorLayer.add(this.previewLine)
        } else {
          this.previewLine.points([lastPoint.x, lastPoint.y, point.x, point.y])
        }

        // Indicador de snap: cambiar color del primer vertice si esta cerca
        const firstCircle = this.vertexCircles[0]
        if (firstCircle) {
          const isNear = this._IsNearFirstPoint(point)
          const radius = this._GetVertexRadius()
          firstCircle.fill(isNear ? '#2ecc71' : '#e74c3c')
          firstCircle.stroke(isNear ? '#27ae60' : '#c0392b')
          firstCircle.radius(isNear ? radius * 1.4 : radius)
        }

        vectorLayer.batchDraw()
      },

      _ClosePolygon() {
        this.blockIdCounter++
        const blockId = this.blockIdCounter
        const flatPoints = this.pointsShape.flatMap(p => [p.x, p.y])

        // Cerrar: agregar primer punto al final
        flatPoints.push(this.pointsShape[0].x, this.pointsShape[0].y)

        this.blocks.push({
          id: blockId,
          name: 'block_' + blockId,
          points: flatPoints,
          fill: this.drawingFillColor,
          closed: true,
          stroke: this.drawingStrokeColor,
          strokeWidth: this.drawingStrokeWidth,
          dash: this.drawingDash.length > 0 ? [...this.drawingDash] : undefined,
          lineCap: 'round',
          lineJoin: this._EdgeToLineJoin(this.drawingEdges),
          opacity: this.drawingOpacity
        })

        // Limpiar estado de dibujo
        this._ClearDrawing()
        this.$emit('epc-viewer-design-mode-drawing', false)
      },

      _UndoLastPoint() {
        if (this.pointsShape.length === 0) return

        const vectorLayer = this.$refs.refVectors.getNode()

        // Eliminar ultimo punto
        this.pointsShape.pop()

        // Eliminar ultimo circulo de vertice
        const lastCircle = this.vertexCircles.pop()
        if (lastCircle) lastCircle.destroy()

        if (this.pointsShape.length === 0) {
          // No quedan puntos, limpiar todo
          this._ClearDrawing()
        } else {
          // Actualizar la linea con los puntos restantes
          this._UpdateDrawingLine()
        }

        vectorLayer.batchDraw()
      },

      _CancelDrawing() {
        this._ClearDrawing()
        this.$emit('epc-viewer-design-mode-drawing', false)
      },

      _ClearDrawing() {
        const vectorLayer = this.$refs.refVectors?.getNode()
        if (vectorLayer) {
          vectorLayer.destroyChildren()
        }

        this.pointsShape = []
        this.drawingLine = null
        this.previewLine = null
        this.vertexCircles = []

        if (vectorLayer) {
          vectorLayer.batchDraw()
        }
      },

      handleDrawingKeyDown(e) {
        if (!this.isDrawing) return

        // Escape: cancelar dibujo completo
        if (e.key === 'Escape') {
          e.preventDefault()
          this._CancelDrawing()
          return
        }

        // Ctrl+Z: deshacer ultimo punto
        if (e.key === 'z' && (e.ctrlKey || e.metaKey)) {
          e.preventDefault()
          this._UndoLastPoint()
          return
        }
      },

      // ========== EDICION DE VERTICES DE BLOQUES ==========

      _GetVertexRadius() {
        const zoomLevel = this.engine.GetZoomLavel() || 1
        return 5 / zoomLevel
      },

      _SelectBlock(blockIndex) {
        // Deseleccionar bloque/texto anterior si hay uno
        this._DeselectBlock()
        this._DeselectTxt()

        this.selectedBlockIndex = blockIndex
        const block = this.blocks[blockIndex]
        if (!block || !block.points || block.points.length < 6) return

        // Guardamos los colores reales. La selección se indica con los vértices
        // editables (no recoloreamos el bloque, para que el panel pueda editar su
        // color/relleno reales en vivo).
        this._originalBlockStroke = block.stroke
        this._originalBlockFill = block.fill

        this.$emit('epc-block-editing', {
          strokeWidth: block.strokeWidth,
          dash: block.dash || [],
          hasFill: this._originalBlockFill && this._originalBlockFill !== 'transparent',
          strokeColor: this._originalBlockStroke,
          fillColor: this._originalBlockFill,
          opacity: block.opacity != null ? block.opacity : 0.7,
          edges: block.lineJoin === 'miter' ? 'sharp' : 'round'
        })

        const vectorLayer = this.$refs.refVectors.getNode()
        const points = block.points
        const radius = this._GetVertexRadius()
        const strokeWidth = Math.max(0.5, 1.5 / (this.engine.GetZoomLavel() || 1))

        // Crear circulos editables en cada vertice (los puntos van en pares x,y)
        // El ultimo par es igual al primero (cierre), lo omitimos
        const numVertices = (points.length / 2) - 1
        for (let i = 0; i < numVertices; i++) {
          const x = points[i * 2]
          const y = points[i * 2 + 1]

          const circle = new Konva.Circle({
            name: 'editVertex',
            x: x,
            y: y,
            radius: radius,
            fill: 'white',
            stroke: '#2980b9',
            strokeWidth: strokeWidth,
            draggable: true,
            hitStrokeWidth: radius * 2,
          })

          const vertexIndex = i
          circle.on('dragmove', () => {
            this._OnVertexDrag(vertexIndex, circle)
          })

          circle.on('mouseover', () => {
            circle.fill('#2980b9')
            circle.radius(radius * 1.2)
            this._SetCursor('move')
            vectorLayer.batchDraw()
          })

          circle.on('mouseout', () => {
            circle.fill('white')
            circle.radius(radius)
            this._SetCursor('default')
            vectorLayer.batchDraw()
          })

          vectorLayer.add(circle)
          this.editVertexCircles.push(circle)
        }

        vectorLayer.batchDraw()
      },

      DeleteSelectedBlock() {
        if (this.selectedBlockIndex === null) return
        const idx = this.selectedBlockIndex
        this._DeselectBlock()
        this.blocks.splice(idx, 1)
      },

      DeleteSelectedTxt() {
        if (this.selectedTxtIndex === null) return
        const idx = this.selectedTxtIndex
        this._DeselectTxt()
        this.txtBlocks.splice(idx, 1)
      },

      UpdateSelectedBlockStrokeWidth(width) {
        if (this.selectedBlockIndex === null) return
        this.$set(this.blocks[this.selectedBlockIndex], 'strokeWidth', width)
      },

      UpdateSelectedBlockDash(dash) {
        if (this.selectedBlockIndex === null) return
        this.$set(this.blocks[this.selectedBlockIndex], 'dash', dash.length > 0 ? dash : undefined)
      },

      UpdateSelectedBlockFill(filled) {
        if (this.selectedBlockIndex === null) return
        const fill = filled ? 'rgba(236, 236, 236, 0.68)' : 'transparent'
        this._originalBlockFill = fill
        this.$set(this.blocks[this.selectedBlockIndex], 'fill', filled ? 'rgba(52, 152, 219, 0.15)' : 'transparent')
      },

      // Panel de propiedades: color de trazo del bloque seleccionado (aplica en vivo
      // y persiste, sincronizando el "original" para que _DeselectBlock lo conserve).
      UpdateSelectedBlockStroke(color) {
        if (this.selectedBlockIndex === null) return
        this._originalBlockStroke = color
        this.$set(this.blocks[this.selectedBlockIndex], 'stroke', color)
      },

      // Panel de propiedades: color de relleno del bloque seleccionado.
      UpdateSelectedBlockFillColor(color) {
        if (this.selectedBlockIndex === null) return
        this._originalBlockFill = color
        this.$set(this.blocks[this.selectedBlockIndex], 'fill', color)
      },

      // Panel de propiedades: opacidad (0..1) del bloque seleccionado.
      UpdateSelectedBlockOpacity(opacity) {
        if (this.selectedBlockIndex === null) return
        this.$set(this.blocks[this.selectedBlockIndex], 'opacity', opacity)
      },

      // 'sharp' → esquinas en pico (miter); 'round' → esquinas redondeadas.
      _EdgeToLineJoin(edges) {
        return edges === 'round' ? 'round' : 'miter'
      },

      // Panel de propiedades: bordes (afilado/redondo) del bloque seleccionado.
      UpdateSelectedBlockEdges(edges) {
        if (this.selectedBlockIndex === null) return
        this.$set(this.blocks[this.selectedBlockIndex], 'lineJoin', this._EdgeToLineJoin(edges))
      },

      // Capas (z-index): el orden de pintado = orden del array. Reordena el elemento
      // seleccionado (bloque o texto) y reapunta su índice. `dir`: to-back|backward|forward|to-front.
      ChangeSelectedZIndex(dir) {
        if (this.selectedBlockIndex !== null) {
          this.selectedBlockIndex = this._MoveInArray(this.blocks, this.selectedBlockIndex, dir)
        } else if (this.selectedTxtIndex !== null) {
          this.selectedTxtIndex = this._MoveInArray(this.txtBlocks, this.selectedTxtIndex, dir)
        }
      },

      // Mueve el elemento `idx` del array según `dir` y devuelve su nuevo índice.
      _MoveInArray(arr, idx, dir) {
        if (idx < 0 || idx >= arr.length) return idx
        let to = idx
        if (dir === 'to-back') to = 0
        else if (dir === 'to-front') to = arr.length - 1
        else if (dir === 'backward') to = Math.max(0, idx - 1)
        else if (dir === 'forward') to = Math.min(arr.length - 1, idx + 1)
        if (to === idx) return idx
        const [el] = arr.splice(idx, 1)
        arr.splice(to, 0, el)
        return to
      },

      _OnVertexDrag(vertexIndex, circle) {
        if (this.selectedBlockIndex === null) return

        const block = this.blocks[this.selectedBlockIndex]
        const points = [...block.points]

        // Actualizar el punto movido
        points[vertexIndex * 2] = circle.x()
        points[vertexIndex * 2 + 1] = circle.y()

        // Si es el primer punto, actualizar tambien el ultimo (cierre del poligono)
        if (vertexIndex === 0) {
          points[points.length - 2] = circle.x()
          points[points.length - 1] = circle.y()
        }

        // Actualizar reactivamente con $set
        this.$set(this.blocks[this.selectedBlockIndex], 'points', points)
      },

      _DeselectBlock() {
        if (this.selectedBlockIndex === null) return

        // Restaurar estilo original del bloque
        const block = this.blocks[this.selectedBlockIndex]
        if (block) {
          this.$set(this.blocks[this.selectedBlockIndex], 'stroke', this._originalBlockStroke || 'black')
          this.$set(this.blocks[this.selectedBlockIndex], 'fill', this._originalBlockFill || 'rgba(236, 236, 236, 0.68)')
        }

        this.$emit('epc-block-editing', null)

        const vectorLayer = this.$refs.refVectors?.getNode()

        // Destruir circulos de edicion
        this.editVertexCircles.forEach(c => c.destroy())
        this.editVertexCircles = []
        this.selectedBlockIndex = null

        if (vectorLayer) {
          vectorLayer.batchDraw()
        }
      },

      // ========== EDICION DE TEXTOS ==========

      _SelectTxt(txtIndex) {
        this._DeselectTxt()
        this._DeselectBlock()

        this.selectedTxtIndex = txtIndex
        const txt = this.txtBlocks[txtIndex]
        if (!txt) return

        const vectorLayer = this.$refs.refVectors.getNode()
        const zoomLevel = this.engine.GetZoomLavel() || 1

        // Crear nodo temporal draggable sobre la capa de vectores
        this.editTxtNode = new Konva.Text({
          name: 'editTxt',
          text: txt.text,
          x: txt.x || 0,
          y: txt.y || 0,
          width: txt.width || undefined,
          fontSize: txt.fontSize || 16,
          fontStyle: txt.fontStyle || 'normal',
          align: txt.align || 'left',
          // Mostramos el color real; la selección la indica el Transformer (borde/anclas).
          fill: txt.fill || '#1e1e1e',
          rotation: txt.rotation || 0,
          draggable: true,
          hitStrokeWidth: 10,
        })

        // Transformer para rotacion y redimension
        this.editTxtTransformer = new Konva.Transformer({
          nodes: [this.editTxtNode],
          enabledAnchors: ['middle-left', 'middle-right'],
          rotateEnabled: true,
          rotateAnchorOffset: 20 / zoomLevel,
          anchorSize: 8 / zoomLevel,
          anchorStroke: '#2980b9',
          anchorFill: 'white',
          anchorCornerRadius: 2 / zoomLevel,
          borderStroke: '#2980b9',
          borderStrokeWidth: Math.max(0.3, 1 / zoomLevel),
          borderDash: [4 / zoomLevel, 2 / zoomLevel],
          boundBoxFunc: function (oldBox, newBox) {
            newBox.width = Math.max(20, newBox.width)
            return newBox
          },
        })

        // Al transformar, normalizar escala a ancho
        this.editTxtNode.on('transform', () => {
          this.editTxtNode.setAttrs({
            width: Math.max(20, this.editTxtNode.width() * this.editTxtNode.scaleX()),
            scaleX: 1,
            scaleY: 1,
          })
        })

        this.editTxtNode.on('transformend dragend', () => {
          this._SyncTxtToData()
        })

        this.editTxtNode.on('mouseover', () => {
          this._SetCursor('move')
        })

        this.editTxtNode.on('mouseout', () => {
          this._SetCursor('default')
        })

        // Ocultar el texto original de la capa refBlocks
        this.$set(this.txtBlocks[txtIndex], 'fill', 'transparent')

        vectorLayer.add(this.editTxtNode)
        vectorLayer.add(this.editTxtTransformer)
        vectorLayer.batchDraw()

        // Emitir datos al padre para los controles del panel de propiedades
        this.$emit('epc-txt-editing', {
          fontSize: txt.fontSize || 16,
          fontStyle: txt.fontStyle || 'normal',
          fill: txt.fill || '#1e1e1e',
          align: txt.align || 'left',
          opacity: txt.opacity != null ? txt.opacity : 1,
        })
      },

      _SyncTxtToData() {
        if (this.selectedTxtIndex === null || !this.editTxtNode) return
        const idx = this.selectedTxtIndex
        this.$set(this.txtBlocks[idx], 'x', this.editTxtNode.x())
        this.$set(this.txtBlocks[idx], 'y', this.editTxtNode.y())
        this.$set(this.txtBlocks[idx], 'width', this.editTxtNode.width())
        this.$set(this.txtBlocks[idx], 'rotation', this.editTxtNode.rotation())
        this.$set(this.txtBlocks[idx], 'fontSize', this.editTxtNode.fontSize())
        this.$set(this.txtBlocks[idx], 'fontStyle', this.editTxtNode.fontStyle())
        this.$set(this.txtBlocks[idx], 'fill', this.editTxtNode.fill())
        this.$set(this.txtBlocks[idx], 'align', this.editTxtNode.align())
        this.$set(this.txtBlocks[idx], 'opacity', this.editTxtNode.opacity())
      },

      // Metodo publico: el padre llama para actualizar fontSize
      UpdateSelectedTxtFontSize(size) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        this.editTxtNode.fontSize(size)
        this.editTxtTransformer.forceUpdate()
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      // Compone fontStyle de Konva a partir de negrita/cursiva: 'bold', 'italic',
      // 'italic bold' o 'normal'.
      _ComposeFontStyle(bold, italic) {
        const parts = []
        if (italic) parts.push('italic')
        if (bold) parts.push('bold')
        return parts.length ? parts.join(' ') : 'normal'
      },

      // Metodo publico: el padre llama para toggle bold (conserva la cursiva actual).
      UpdateSelectedTxtBold(bold) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        const italic = (this.editTxtNode.fontStyle() || '').includes('italic')
        this.editTxtNode.fontStyle(this._ComposeFontStyle(bold, italic))
        this.editTxtTransformer.forceUpdate()
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      // Metodo publico: toggle cursiva (conserva la negrita actual).
      UpdateSelectedTxtItalic(italic) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        const bold = (this.editTxtNode.fontStyle() || '').includes('bold')
        this.editTxtNode.fontStyle(this._ComposeFontStyle(bold, italic))
        this.editTxtTransformer.forceUpdate()
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      // Metodo publico: el padre llama para cambiar el color del texto
      UpdateSelectedTxtColor(color) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        this.editTxtNode.fill(color)
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      // Metodo publico: el padre llama para cambiar el alineado del texto
      UpdateSelectedTxtAlign(align) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        this.editTxtNode.align(align)
        if (this.editTxtTransformer) this.editTxtTransformer.forceUpdate()
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      // Metodo publico: opacidad (0..1) del texto seleccionado.
      UpdateSelectedTxtOpacity(opacity) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        this.editTxtNode.opacity(opacity)
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      _DeselectTxt() {
        if (this.selectedTxtIndex === null) return

        // Sincronizar datos finales (incluye color y alineado elegidos en el panel).
        // El texto estático recupera su color real desde el nodo de edición, por lo que
        // ya no se fuerza un color fijo aquí.
        this._SyncTxtToData()

        const vectorLayer = this.$refs.refVectors?.getNode()
        if (vectorLayer) {
          if (this.editTxtTransformer) {
            this.editTxtTransformer.destroy()
            this.editTxtTransformer = null
          }
          if (this.editTxtNode) {
            this.editTxtNode.destroy()
            this.editTxtNode = null
          }
          vectorLayer.batchDraw()
        }

        this.selectedTxtIndex = null
        this.$emit('epc-txt-editing', null)
      },

      handleWheel(e) {
        if (!this.engine || !this.stage) return
        // Evita el scroll de la página; zoom AL PUNTERO. La rueda del ratón llega como
        // wheel normal; el pinch del touchpad llega como wheel + ctrlKey (ZoomStagePoiter
        // ya invierte la dirección en ese caso).
        if (e.evt && e.evt.preventDefault) e.evt.preventDefault()
        this.engine.ZoomStagePoiter(e, 1.05)
        this._MaybeUpdateLod()
        // Tras zoom, el popover/callout quedan con coords antiguas → cerrarlos.
        if (this.selectedElement) this._CloseElementPopover()
        this._ClearHoverCallout()
        this.$emit('epc-zoom-changed')
      },

      _InsertTextField(position) {
        const vectorLayer = this.$refs.refVectors.getNode()
        const zoomLevel = this.engine.GetZoomLavel() || 1
        // Defaults desde el panel (color/tamaño/negrita/alineado/opacidad).
        const fontSize = (this.drawingTextFontSize || 16) / zoomLevel

        const txt = new Konva.Text({
          text: '',
          x: position.x,
          y: position.y,
          fontSize: fontSize,
          fill: this.drawingTextColor || '#1e1e1e',
          align: this.drawingTextAlign || 'left',
          fontStyle: this._ComposeFontStyle(this.drawingTextBold, this.drawingTextItalic),
          opacity: this.drawingTextOpacity != null ? this.drawingTextOpacity : 1,
          draggable: true,
          width: 200 / zoomLevel,
        })

        const tr = new Konva.Transformer({
          node: txt,
          enabledAnchors: ['middle-left', 'middle-right'],
          boundBoxFunc: function (oldBox, newBox) {
            newBox.width = Math.max(30, newBox.width)
            return newBox
          },
        })

        txt.on('transform', function () {
          txt.setAttrs({
            width: txt.width() * txt.scaleX(),
            scaleX: 1,
          })
        })

        vectorLayer.add(txt)
        vectorLayer.add(tr)
        vectorLayer.batchDraw()

        // Abrir textarea inmediatamente para escribir
        this._OpenTextEditor(txt, tr)

        // La herramienta queda ARMADA (el panel sigue abierto y se pueden colocar más
        // textos). Se sale con el botón Selección o Esc (lo gestiona la página).
      },

      _OpenTextEditor(txtNode, transformer) {
        txtNode.hide()
        if (transformer) transformer.hide()

        const stage = this.$refs.stage.getNode()
        const container = this.$refs.canvasContainer
        const textPosition = txtNode.absolutePosition()
        const stageRect = stage.container().getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()

        // Posicion relativa al contenedor del canvas
        const areaPosition = {
          x: stageRect.left - containerRect.left + textPosition.x,
          y: stageRect.top - containerRect.top + textPosition.y,
        }

        const scale = txtNode.getAbsoluteScale().x

        const textarea = document.createElement('textarea')
        container.appendChild(textarea)

        textarea.value = txtNode.text()
        textarea.style.position = 'absolute'
        textarea.style.top = areaPosition.y + 'px'
        textarea.style.left = areaPosition.x + 'px'
        textarea.style.width = (txtNode.width() * scale) + 'px'
        textarea.style.fontSize = (txtNode.fontSize() * scale) + 'px'
        textarea.style.border = '1px dashed #2980b9'
        textarea.style.padding = '2px'
        textarea.style.margin = '0px'
        textarea.style.overflow = 'hidden'
        textarea.style.background = 'rgba(255,255,255,0.9)'
        textarea.style.outline = 'none'
        textarea.style.resize = 'none'
        textarea.style.lineHeight = String(txtNode.lineHeight())
        textarea.style.fontFamily = txtNode.fontFamily()
        textarea.style.transformOrigin = 'left top'
        textarea.style.textAlign = txtNode.align()
        textarea.style.color = txtNode.fill()
        textarea.style.zIndex = '1000'
        textarea.style.minHeight = '30px'
        textarea.style.height = 'auto'
        textarea.style.height = Math.max(30, textarea.scrollHeight + 3) + 'px'

        textarea.focus()

        const self = this
        let saved = false

        const saveAndClose = (saveText) => {
          if (saved) return
          saved = true

          textarea.removeEventListener('keydown', handleKeydown)
          window.removeEventListener('mousedown', handleOutsideClick)

          if (saveText && textarea.value.trim()) {
            // Guardar en txtBlocks para persistir
            self.txtBlockIdCounter++
            self.txtBlocks.push({
              id: self.txtBlockIdCounter,
              name: 'txtblock_' + self.txtBlockIdCounter,
              text: textarea.value,
              x: txtNode.x(),
              y: txtNode.y(),
              fontSize: txtNode.fontSize(),
              fontStyle: txtNode.fontStyle(),
              fill: txtNode.fill(),
              align: txtNode.align(),
              opacity: txtNode.opacity(),
            })
          }

          // Limpiar nodo temporal y textarea
          txtNode.destroy()
          if (transformer) transformer.destroy()
          if (textarea.parentNode) textarea.parentNode.removeChild(textarea)

          const vectorLayer = self.$refs.refVectors?.getNode()
          if (vectorLayer) vectorLayer.batchDraw()
        }

        const handleKeydown = (e) => {
          // Enter (sin Shift) confirma
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            saveAndClose(true)
            return
          }
          // Escape cancela
          if (e.key === 'Escape') {
            e.preventDefault()
            saveAndClose(false)
            return
          }
          // Auto-resize altura
          textarea.style.height = 'auto'
          textarea.style.height = Math.max(30, textarea.scrollHeight + 3) + 'px'
        }

        const handleOutsideClick = (e) => {
          if (e.target !== textarea) {
            saveAndClose(true)
          }
        }

        textarea.addEventListener('keydown', handleKeydown)
        // Delay para evitar que el click que abrio el editor lo cierre
        setTimeout(() => {
          window.addEventListener('mousedown', handleOutsideClick)
        }, 100)
      },

      handleContextMenu(e) {
        // prevent default behavior
        // console.log('handleContextMenu: ', e)
        // e.evt.preventDefault();
        // e.evt.stopPropagation()
        // const stage = this.$refs.stage.getNode();

        // if (e.target === stage) {
        //   // if we are on empty place of the stage we will do nothing
        //   return;
        // }
        // let currentShape = e.target;
        // console.log('handleContextMenu: ', currentShape)
        // show menu
        // menuNode.style.display = 'initial';
        // var containerRect = stage.container().getBoundingClientRect();
        // menuNode.style.top =
        //   containerRect.top + stage.getPointerPosition().y + 4 + 'px';
        // menuNode.style.left =
        //   containerRect.left + stage.getPointerPosition().x + 4 + 'px';
      },

      async _Screenshot() {
        return new Promise((resolve, reject) => {
          // let timeOut = null;
          // const l = ()=>{
          //     timeOut && window.clearTimeout(timeOut);
          //     try {
          //       console.log('screenshot')\
              this.$emit('epc-screenshot', this.engine.Screenshot());
              resolve()
          //       timeOut = window.setTimeout(l, 1e3)
          //     } catch (e) {
          //       console.log(e)
          //     }
          // };
          // l()
        })
      },

      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },

      ZoomIn() {
        this.engine.ZoomStage(1.2)
        this._MaybeUpdateLod()
      },

      ZoomOut() {
        this.engine.ZoomStage(0.8)
        this._MaybeUpdateLod()
      },

      // Umbral de zoom para pasar a detalle (tunable en data.lodZoomThreshold). Con el
      // culling por viewport el detalle solo se construye en los bloques visibles, así
      // que el umbral puede ser bajo sin penalizar.
      _ShouldLodDetail() {
        return this.GetZoomLevel() >= this.lodZoomThreshold
      },

      // Recalcula si el zoom pasó el umbral y aplica el culling por viewport. Sin
      // re-ajustar (preserva el zoom/pan).
      _MaybeUpdateLod() {
        if (!this.lodEnabled || this.focusedGroupId) return
        this._lodDetail = this._ShouldLodDetail()
        this._ApplyLod()
      },

      // Construye la shape de UN bloque: detalle (sceneFunc) o silueta (1 rect por %),
      // reemplazando la anterior. Marca el estado en el grupo (attr 'lodDetail').
      _BuildBlockShape(group, picId, type, detail) {
        group.find('.entitiesShape').forEach(s => s.destroy())
        group.find('.blockSilhouette').forEach(s => s.destroy())

        const entities = this.scenes[picId] && this.scenes[picId].entitiesByType
          ? this.scenes[picId].entitiesByType[type]
          : []
        const shape = detail
          ? this._CreateEntitiesShape(entities)
          : this._CreateBlockSilhouette(entities, this._BlockProgressColor(picId, type))
        if (shape) group.add(shape)
        group.setAttr('lodDetail', detail)
      },

      // ¿El bbox del bloque (coords de pantalla) intersecta el viewport visible?
      _blockInViewport(group) {
        const container = this.$refs.canvasContainer
        if (!container) return true
        const vw = container.offsetWidth
        const vh = container.offsetHeight
        const box = group.getClientRect()
        return box.x < vw && (box.x + box.width) > 0 && box.y < vh && (box.y + box.height) > 0
      },

      // Culling por viewport del LOD: con el zoom por encima del umbral, sube a DETALLE
      // solo los bloques VISIBLES; el resto (y en overview) quedan en silueta. Reconstruye
      // únicamente los bloques cuyo estado cambió. No aplica en foco.
      _ApplyLod() {
        if (!this.lodEnabled || this.focusedGroupId) return
        const layer = this.$refs.layer && this.$refs.layer.getNode()
        if (!layer) return

        let changed = false
        layer.find('Group').forEach(group => {
          const target = this._lodDetail && this._blockInViewport(group)
          if (group.getAttr('lodDetail') !== target) {
            const picId = parseInt(String(group.id()).replace('GroupPictogram_', ''), 10)
            this._BuildBlockShape(group, picId, this.pictogramType, target)
            changed = true
          }
        })
        if (changed) layer.batchDraw()
      },

      // Zoom RELATIVO al fit del parque (fit = 1 = 100%): escala actual del stage /
      // escala al hacer fit. Así "fit" muestra 100% directo y al acercar sube.
      GetZoomLevel() {
        const scale = this.stage ? this.stage.scaleX() : 1
        const base = this._fitScale || scale
        return base ? scale / base : 1
      },

      FitToScreen() {

        return new Promise((resolve, reject) => {

          this.engine.FitToScreen()
            .then(result => {
              // Fit del overview (no foco) → escala base del 100%.
              if (!this.focusedGroupId) this._fitScale = this.stage.scaleX()
              // Al volver al fit, el zoom baja del umbral → re-evaluar LOD (siluetas).
              this._MaybeUpdateLod()
              resolve();//this._Screenshot()
            })

        })
      },

      // Función para manejar el evento de redimensionamiento
      handleResize() {
        this.engine.Resize()
      },

      _AllowedAction(action) {
        if (Object.keys(this.canActionsPictogram).length === 0)
          return false;

        return this.canActionsPictogram[action] === 'undefined' ? false : this.canActionsPictogram[action]
      },

      _GetLayerOrder() {
        const stage = this.$refs.stage.getStage();
        return stage.getChildren().map(layer => layer.getAttr('id'));
      },







    handleDragover(e) {
      e.preventDefault(); // !important
    },

    _FindGroupAtPoint(mousePos) {
      const layer = this.$refs.layer.getNode()
      const groups = layer.find('Group')
      for (let i = groups.length - 1; i >= 0; i--) {
        const group = groups[i]
        const box = group.getClientRect()
        if (isPointInRect(mousePos, box)) {
          return group.id()
        }
      }
      return null
    },

    // --- Modo vista: hover enmarca el bloque, click lo enfoca (zoom + ocultar los demás) ---

    // Interacciones de vista (hover de datos, foco por doble-click, click) activas por
    // contexto. Flag ON por defecto; un contexto las apaga con view_interactions:false
    // en canActionsPictogram (p.ej. el webviewer del bot, que no interactúa).
    _InteractionsEnabled() {
      return this.canActionsPictogram.view_interactions !== false
    },

    _HandleViewHover() {
      if (!this._InteractionsEnabled()) { this._ClearHoverCallout(); return }
      if (this.showAreas) { this._SetCursor('default'); this._ClearHoverCallout(); return }
      // En foco (bloque ampliado) el hover es POR ELEMENTO, no por bloque.
      if (this.focusedGroupId) { this._HandleElementHover(); return }

      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return

      const foundGroupId = this._FindGroupAtPoint(mousePos)
      this._SetCursor(foundGroupId ? 'pointer' : 'default')

      if (foundGroupId === this.hoveredGroupId) return

      this._ClearHighlight('hover')
      this.hoveredGroupId = foundGroupId
      if (foundGroupId) {
        const node = this.stage.findOne('#' + foundGroupId)
        // Padding mayor (20) para el marco del modo vista; el de diseño sigue en 4.
        if (node) this._ApplyHighlight(node, 'hover', 20)
        // Callout con el nombre del bloque (overlay HTML, se mantiene el marco).
        this.hoverCallout = this._BuildHoverCallout(foundGroupId)
        this.$emit('epc-hover-block', parseInt(String(foundGroupId).replace('GroupPictogram_', ''), 10))
      } else {
        this._ClearHoverCallout()
      }
      this.$refs.layer.getNode().batchDraw()
    },

    _ClearHoverCallout() {
      if (this.hoverCallout) this.hoverCallout = null
      this.$emit('epc-hover-block', null)
      this._ClearElementHover()
    },

    // --- Modo foco (bloque ampliado): hover + resaltado POR ELEMENTO ---
    // Los elementos no son nodos Konva (se pintan en un sceneFunc con listening:false),
    // así que el hit-test es manual contra la geometría de cada entidad (rects).

    _HandleElementHover() {
      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) { this._ClearElementHover(); this._SetCursor('default'); return }

      const hit = this._FindEntityAtPoint(mousePos)
      if (!hit) {
        this._SetCursor('default')
        if (this._hoveredEntityId != null) this._ClearElementHover()
        return
      }

      this._SetCursor('pointer')
      if (hit.entity.id === this._hoveredEntityId) return
      this._hoveredEntityId = hit.entity.id
      this._ApplyElementHighlight(hit.group, hit.entity)
    },

    // Entidad bajo el puntero dentro del bloque enfocado (o null). Convierte el puntero
    // a coords locales del grupo e itera los rects; el último que contiene el punto gana
    // (los de encima se dibujan después).
    _FindEntityAtPoint(mousePos) {
      if (!this.focusedGroupId) return null
      const picId = parseInt(String(this.focusedGroupId).replace('GroupPictogram_', ''), 10)
      const group = this.stage.findOne('#' + this.focusedGroupId)
      if (!group) return null

      const view = this.pictogramType
      const entities = this.scenes[picId] && this.scenes[picId].entitiesByType
        ? this.scenes[picId].entitiesByType[view]
        : null

      // El motor convierte el puntero a coords locales del grupo; el hit-test es puro.
      const transform = group.getAbsoluteTransform().copy()
      transform.invert()
      const entity = findEntityAtLocalPoint(entities, transform.point(mousePos))
      return entity ? { group, entity, picId, view } : null
    },

    // Resalta una entidad con un rect overlay (borde azul app + relleno sutil). El grosor
    // se mantiene constante en pantalla (strokeScaleEnabled:false) pese al zoom.
    _ApplyElementHighlight(group, entity) {
      this._ClearElementHover(false)
      const rect = new Konva.Rect({
        name: 'entityHover',
        x: entity.x,
        y: entity.y,
        width: entity.width,
        height: entity.height,
        stroke: '#3a6bc8',
        strokeWidth: 1.5,
        strokeScaleEnabled: false,
        fill: 'rgba(58, 107, 200, 0.18)',
        listening: false,
      })
      group.add(rect)
      this._entityHoverRect = rect
      group.getLayer().batchDraw()
    },

    _ClearElementHover(redraw = true) {
      if (this._entityHoverRect) {
        this._entityHoverRect.destroy()
        this._entityHoverRect = null
      }
      this._hoveredEntityId = null
      if (redraw && this.$refs.layer && this.$refs.layer.getNode()) {
        this.$refs.layer.getNode().batchDraw()
      }
    },

    // Resaltado PERSISTENTE del elemento con popover abierto (más marcado que el hover).
    _ApplySelectedElementHighlight(group, entity) {
      this._ClearSelectedElementHighlight(false)
      const rect = new Konva.Rect({
        name: 'entitySelected',
        x: entity.x,
        y: entity.y,
        width: entity.width,
        height: entity.height,
        stroke: '#3a6bc8',
        strokeWidth: 2.5,
        strokeScaleEnabled: false,
        fill: 'rgba(58, 107, 200, 0.3)',
        listening: false,
      })
      group.add(rect)
      this._entitySelectedRect = rect
      group.getLayer().batchDraw()
    },

    _ClearSelectedElementHighlight(redraw = true) {
      if (this._entitySelectedRect) {
        this._entitySelectedRect.destroy()
        this._entitySelectedRect = null
      }
      if (redraw && this.$refs.layer && this.$refs.layer.getNode()) {
        this.$refs.layer.getNode().batchDraw()
      }
    },

    // Cierra el popover de elemento y quita su resaltado.
    _CloseElementPopover() {
      this.selectedElement = null
      this._ClearSelectedElementHighlight()
    },

    // Construye el callout (nombre + línea punteada) del bloque en coords de pantalla
    // (relativas al canvasContainer). El nombre sale de parts.pictogram.name (ya cargado).
    // Info del pictograma (bloque) para callout/resumen: nombre, actividad + su avance,
    // y avance por capa (hincados/estructuras/módulos) desde layer.metadata.progress_layer
    // (ya persistido y cargado con el power plant). Reutilizado por hover y por el resumen.
    _PictogramInfo(picId) {
      const parts = (this.powerPlant && this.powerPlant.parts) || []
      const part = parts.find(p => String(p.pictogram_id) === String(picId))
      const pic = part && part.pictogram
      if (!pic) return null

      const act = pic.activities && pic.activities.length ? pic.activities[0] : null

      // Avance por capa, CONSCIENTE DE COMPANY (igual que el dashboard FV):
      //  - x-elio: ejecutado/total (su `advance_normalize` se guarda en 0, no sirve).
      //    total = pic.metadata['total_'+code]; ejecutado = pic.metadata.total_progress[code].
      //  - resto: layer.metadata.progress_layer.advance_normalize (ya viene como %).
      const company = store.getters['app/company']
      const isXelio = company && company.alias === 'x-elio'
      const meta = pic.metadata || {}
      const totalProgress = meta.total_progress || {}
      const layers = []
      for (const code of ['pilings', 'structures', 'modules']) {
        const lyr = pic.layers ? pic.layers.find(l => l.code === code) : null
        const pl = lyr && lyr.metadata ? lyr.metadata.progress_layer : null
        let pct = null
        if (isXelio) {
          const total = Number(meta['total_' + code] || 0)
          if (!(total > 0)) continue // sin total no hay % con sentido
          const executed = Number((totalProgress[code] != null ? totalProgress[code] : (pl ? pl.elements_active : 0)) || 0)
          pct = (executed / total) * 100
        } else {
          if (!pl) continue
          pct = Number(pl.advance_normalize || 0)
        }
        layers.push({ code, pct: Math.max(0, Math.min(100, Math.round(pct))) })
      }

      return {
        name: pic.name || null,
        activity: act ? act.name : null,
        activityProgress: act && act.progress != null ? Math.round(Number(act.progress)) : null,
        layers,
      }
    },

    _BuildHoverCallout(groupId) {
      const picId = parseInt(String(groupId).replace('GroupPictogram_', ''), 10)
      const info = this._PictogramInfo(picId)
      const node = this.stage && this.stage.findOne('#' + groupId)
      if (!info || !info.name || !node) return null

      const box = node.getClientRect() // coords de pantalla (el stage llena el contenedor)
      const container = this.$refs.canvasContainer
      const cw = container ? container.offsetWidth : 0
      const ch = container ? container.offsetHeight : 0

      const offset = 22            // separación bloque↔píldora
      // Alto estimado según el contenido (PB + actividad + barra + capas).
      const rows = 1 + (info.activity ? 1 : 0) + (info.activityProgress != null ? 1 : 0)
      const labelH = 16 + rows * 18 + info.layers.length * 16
      const longest = Math.max(String(info.name).length + 4, info.activity ? String(info.activity).length + 10 : 0)
      const approxW = Math.min(300, 56 + longest * 7) // ancho estimado (solo para decidir el lado)

      // Ancho usable a la DERECHA: si el panel lateral flota abierto (no acoplado), tapa
      // la franja derecha → se descuenta para que el callout prefiera la izquierda.
      const usableRight = cw - (this.rightInset || 0)

      // Lado horizontal: derecha si cabe, si no izquierda. Esquina superior como ancla.
      const side = (box.x + box.width + offset + approxW <= usableRight) ? 'right' : 'left'
      const anchorX = side === 'right' ? (box.x + box.width) : box.x
      const anchorY = box.y

      // La píldora se ancla por su BORDE INTERIOR a `edgeX` (CSS left a la derecha / right a
      // la izquierda) → la línea conecta EXACTO sin depender del ancho real (fin del desfase).
      const edgeX = side === 'right' ? (anchorX + offset) : (anchorX - offset)

      // Vertical: arriba si cabe, si no abajo. Clampado a los bordes. El tope superior
      // deja libre la franja de la toolbar (arriba) para que el callout no la tape: si
      // colisionaría con ella, se empuja más abajo.
      const TOP_SAFE = 72 // alto de la toolbar flotante + aire para no pegarse a ella
      const up = (anchorY - offset - labelH >= TOP_SAFE)
      const pillTop = up ? (anchorY - offset - labelH) : (anchorY + offset)
      const pillTopC = Math.max(TOP_SAFE, Math.min(pillTop, ch - labelH - 4))

      const lineY2 = pillTopC + 12

      return {
        ...info,
        side,
        anchor: { x: Math.round(anchorX), y: Math.round(anchorY) },
        pill: {
          top: Math.round(pillTopC),
          left: side === 'right' ? Math.round(edgeX) : null,
          right: side === 'left' ? Math.round(cw - edgeX) : null,
        },
        line: { x1: Math.round(anchorX), y1: Math.round(anchorY), x2: Math.round(edgeX), y2: Math.round(lineY2) },
      }
    },

    // Click SIMPLE en modo vista: muestra info resumida del bloque (el padre abre el
    // panel de resumen). El ZOOM pasó al doble click (handleDblClick).
    _HandleViewClick() {
      if (!this._InteractionsEnabled()) return
      if (this.showAreas) return
      // En foco (bloque ampliado), el click es POR ELEMENTO → abre/actualiza su popover.
      if (this.focusedGroupId) { this._HandleElementClick(); return }

      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return

      const groupId = this._FindGroupAtPoint(mousePos)
      if (groupId) this.$emit('epc-select-block', this._BuildBlockSummary(groupId))
    },

    // Click en un elemento del bloque enfocado → abre el popover; click en vacío → lo cierra.
    _HandleElementClick() {
      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return
      const hit = this._FindEntityAtPoint(mousePos)
      if (!hit) { this._CloseElementPopover(); return }
      this.selectedElement = this._BuildElementInfo(hit)
      this._ApplySelectedElementHighlight(hit.group, hit.entity)
    },

    // Prepara los datos del popover: identificación del componente + geometría de pantalla
    // (ancla = centro de la entidad; box = su rect) en coords del contenedor (= coords del
    // stage, que lo llena). El nombre del endpoint tiene prioridad; aquí va el fallback.
    _BuildElementInfo(hit) {
      const { group, entity, picId, view } = hit
      // El motor aporta la proyección local→pantalla; la geometría (ancla/box) es pura.
      const abs = group.getAbsoluteTransform().copy()
      const { anchor, box } = buildElementScreenGeometry(entity, pt => abs.point(pt))

      const container = this.$refs.canvasContainer
      const bounds = {
        width: container ? container.offsetWidth : this.configKonva.width,
        height: container ? container.offsetHeight : this.configKonva.height,
      }
      return {
        source: {
          pictogramId: picId,
          componentId: entity.id,
          type: view,
          name: entity.id,
        },
        anchor,
        box,
        bounds,
      }
    },

    // Doble click en modo vista: enfoca el bloque (zoom + ocultar los demás).
    handleDblClick(e) {
      if (!this._InteractionsEnabled()) return
      if (this.designMode || this.showAreas || this.focusedGroupId) return
      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return
      const groupId = this._FindGroupAtPoint(mousePos)
      if (groupId) this.FocusGroup(groupId)
    },

    // Resumen del bloque (pictograma) para el panel: reutiliza _PictogramInfo.
    _BuildBlockSummary(groupId) {
      const picId = parseInt(String(groupId).replace('GroupPictogram_', ''), 10)
      const info = this._PictogramInfo(picId) || {}
      return { picId, groupId, ...info }
    },

    // Enfoca un bloque: oculta los demás grupos y hace zoom (FitToScreen ignora los
    // ocultos vía getClientRect, así ajusta al único visible).
    FocusGroup(groupId) {
      this._ClearHighlight('hover')
      this._ClearHoverCallout()
      this.hoveredGroupId = null
      this.focusedGroupId = groupId
      // Render reconstruye: el enfocado al DETALLE, los demás silueta-pero-ocultos; su
      // FitToScreen final ajusta al único visible → zoom al bloque.
      this.Render(this.pictogramType)
      // Etiquetas (nombres de estructuras) del bloque enfocado, desde Mongo (async).
      this._LoadFocusLabels(groupId)
      this._SetCursor('default')
      this.$emit('epc-focus-group', groupId)
    },

    // Vuelve a la vista completa del parque (todas las siluetas).
    UnfocusGroup() {
      this.focusedGroupId = null
      this._CloseElementPopover() // cerrar el popover de elemento y su resaltado al salir del foco
      this._ClearHighlight('hover')
      this._ClearHoverCallout()
      this.hoveredGroupId = null
      this._ClearFocusLabels()
      this.Render(this.pictogramType)
      this.$emit('epc-focus-group', null)
    },

    // Pide a Mongo los nombres del pictograma enfocado y pinta una etiqueta de texto
    // por estructura (solo en foco → pocos nodos). Posición como GetEntities (vertical
    // → rotación -90). Si se dejó de enfocar ese bloque mientras llegaba, no hace nada.
    async _LoadFocusLabels(groupId) {
      const picId = parseInt(String(groupId).replace('GroupPictogram_', ''), 10)
      if (!picId || !this.powerPlant || !this.powerPlant.id) return
      const view = this.pictogramType

      try {
        const { data } = await fetchPictogramNames(this.powerPlant.id, picId, view)
        const names = data && data.names
        if (!names || this.focusedGroupId !== groupId) return

        const group = this.stage.findOne('#' + groupId)
        if (!group) return

        this._ClearFocusLabels()
        const entities = this.scenes[picId] && this.scenes[picId].entitiesByType
          ? this.scenes[picId].entitiesByType[view]
          : []

        for (const e of entities) {
          const name = names[String(e.id)]
          if (name == null) continue
          const vertical = e.width < e.height
          group.add(new Konva.Text({
            name: 'focusLabel',
            text: String(name),
            x: e.x,
            y: e.y + (vertical ? e.height : 0),
            width: vertical ? e.height : e.width,
            height: vertical ? e.width : e.height,
            fontSize: 2,
            fill: '#000000',
            align: 'center',
            verticalAlign: 'middle',
            rotation: vertical ? -90 : 0,
            listening: false,
          }))
        }
        group.getLayer().batchDraw()
      } catch (error) {
        // Sin nombres (o error) → sin etiquetas, no rompe nada.
      }
    },

    _ClearFocusLabels() {
      const layer = this.$refs.layer && this.$refs.layer.getNode()
      if (layer) layer.find('.focusLabel').forEach(n => n.destroy())
    },

    _SetCursor(type) {
      const container = this.stage.container()
      container.style.cursor = type
    },

    // Al terminar un paneo (la stage es draggable en modo navegación), re-aplica el
    // culling por viewport para subir a detalle los bloques que entraron en pantalla.
    // En diseño no aplica (bubbling del dragend de un grupo); _ApplyLod ya se autoguarda.
    handleStageDragEnd(e) {
      // El popover/callout quedan con coords antiguas tras panear → cerrarlos.
      if (this.selectedElement) this._CloseElementPopover()
      this._ClearHoverCallout()
      if (!this.designMode) this._ApplyLod()
    },

    handleMouseUp(e) {
      this._isMouseDown = false
      if (this._isPanMode) {
        this._SetCursor('grab')
      }
      if (!this.designMode || this.showAreas || !this.selectedGroupId) return

      // Al soltar el botón, cambiar cursor a grab si está sobre el grupo seleccionado
      const mousePos = this.stage.getPointerPosition()
      if (mousePos) {
        const foundGroupId = this._FindGroupAtPoint(mousePos)
        if (foundGroupId === this.selectedGroupId) {
          this._SetCursor('grab')
        } else {
          this._SetCursor('default')
        }
      }
    },

    handleMouseOver(e) {
      if (this._isPanMode) return
      if (!this.designMode) {
        // Modo vista: hover enmarca el bloque (reusa el highlight) + cursor pointer.
        this._HandleViewHover()
        return
      }

      // Si esta dibujando, delegar al preview de dibujo
      if (this.isDrawing) {
        this._SetCursor('crosshair')
        this.handleDrawingMouseMove(e)
        return
      }

      // Si la herramienta de texto esta activa, mostrar cursor text
      if (this.selectedTool === 'pencil') {
        this._SetCursor('text')
        return
      }

      // Cuando showAreas esta activo, no interactuar con grupos
      if (this.showAreas) return

      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return

      // Durante drag con botón pulsado, mantener grabbing
      if (this.isDragging && this._isMouseDown) {
        this._SetCursor('grabbing')
        return
      }

      const foundGroupId = this._FindGroupAtPoint(mousePos)

      // Cursor según contexto
      if (this.selectedGroupId && foundGroupId === this.selectedGroupId) {
        this._SetCursor('grab')
      } else if (foundGroupId) {
        this._SetCursor('pointer')
      } else {
        this._SetCursor('default')
      }

      // Si el hover no cambió, no hacer nada más
      if (foundGroupId === this.hoveredGroupId) return

      // Limpiar hover anterior
      this._ClearHighlight('hover')
      this.hoveredGroupId = foundGroupId

      if (this.hoveredGroupId && this.hoveredGroupId !== this.selectedGroupId) {
        const hoveredNode = this.stage.findOne(`#${this.hoveredGroupId}`)
        if (hoveredNode) {
          this._ApplyHighlight(hoveredNode, 'hover')
        }
      }

      this.$refs.layer.getNode().batchDraw()
    },

    handleMouseDown(e) {
      if (this._isPanMode) {
        this._SetCursor('grabbing')
      }
      if (!this.designMode || this.isDrawing || this.showAreas) return
      this._isMouseDown = true

      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return

      const clickedGroupId = this._FindGroupAtPoint(mousePos)

      // Mousedown en vacío o en otro grupo → deseleccionar el actual
      if (this.selectedGroupId && clickedGroupId !== this.selectedGroupId) {
        this._DeselectGroup()
        this.$refs.layer.getNode().batchDraw()
        this._ignoreClick = true // Ignorar el click que viene después
        return
      }

      // Mousedown en vacío sin selección → ignorar
      if (!clickedGroupId) return

      this._SetCursor('grabbing')

      // Si es el mismo grupo ya seleccionado, reactivar drag con startDrag
      if (this.selectedGroupId === clickedGroupId) {
        const groupNode = this.stage.findOne(`#${this.selectedGroupId}`)
        if (groupNode) {
          groupNode.startDrag()
          this.isDragging = true
          this._hasDragged = false
          this._ignoreClick = true
        }
        return
      }

      const layer = this.$refs.layer.getNode()
      const groupNode = this.stage.findOne(`#${clickedGroupId}`)

      // Seleccionar nuevo grupo
      this._ClearHighlight('hover')
      this._ClearHighlight('selected')
      this.selectedGroupId = clickedGroupId
      this.hoveredGroupId = null

      this._ApplyHighlight(groupNode, 'selected')

      groupNode.draggable(true)
      groupNode.moveToTop()
      groupNode.moveTo(layer)

      this.isDragging = true
      this._hasDragged = false
      this._ignoreClick = true

      // Escuchar dragmove para saber si realmente se movió
      groupNode.off('dragmove.select')
      groupNode.on('dragmove.select', () => {
        this._hasDragged = true
      })

      // Arrancar el drag YA en este mismo mousedown: como las entidades son listening:false,
      // Konva no inicia el drag nativo solo, así que el primer gesto seleccionaba pero no
      // movía (había que soltar y volver a arrastrar). Un clic sin mover sigue siendo solo
      // selección (termina el drag sin desplazamiento).
      groupNode.startDrag()

      layer.batchDraw()
    },

    handleClick(e) {
      if (!this.designMode) {
        // Modo vista: click en un bloque → modo foco (zoom + ocultar los demás).
        this._HandleViewClick()
        return
      }

      // Si esta dibujando, delegar al click de dibujo
      if (this.isDrawing) {
        this.handleDrawingClick(e)
        return
      }

      // Si la herramienta de texto esta activa, insertar texto en la posicion del click
      if (this.selectedTool === 'pencil') {
        const point = this._GetMousePointTransformed()
        if (point) {
          this._InsertTextField(point)
        }
        return
      }

      // Cuando showAreas esta activo, solo interactuar con bloques y textos (no con grupos)
      if (this.showAreas) {
        const point = this._GetMousePointTransformed()
        if (point) {
          // Primero verificar click en texto
          const txtIndex = findTxtAtPoint(this.txtBlocks, point)
          if (txtIndex !== null) {
            if (this.selectedTxtIndex === txtIndex) {
              this._DeselectTxt()
            } else {
              this._SelectTxt(txtIndex)
            }
            return
          }

          // Luego verificar click en bloque
          const blockIndex = findBlockAtPoint(this.blocks, point)
          if (blockIndex !== null) {
            if (this.selectedBlockIndex === blockIndex) {
              this._DeselectBlock()
            } else {
              this._SelectBlock(blockIndex)
            }
          } else {
            // Click fuera de bloques y textos → deseleccionar todo
            this._DeselectBlock()
            this._DeselectTxt()
          }
        }
        return
      }

      // Ignorar el click que viene justo después de un mousedown que seleccionó
      if (this._ignoreClick) {
        this._ignoreClick = false

        // Si se movió durante el drag → soltar, mantener seleccionado
        if (this._hasDragged) {
          const node = this.stage.findOne(`#${this.selectedGroupId}`)
          if (node) {
            node.draggable(false)
            node.off('dragmove.select')
          }
          this.isDragging = false

          this._ClearHighlight('selected')
          if (node) {
            this._ApplyHighlight(node, 'selected')
          }
          this.$refs.layer.getNode().batchDraw()
        }
        return
      }

      // Click con grupo seleccionado (sin drag activo) → deseleccionar
      if (this.selectedGroupId) {
        this._DeselectGroup()
        this.$refs.layer.getNode().batchDraw()
        return
      }
    },

    _emitSelectedCount() {
      let count = 0
      if (this.selectedGroupId) count++
      if (this.selectedBlockIndex !== null) count++
      if (this.selectedTxtIndex !== null) count++
      this.$emit('epc-selected-count', count)
    },

    _DeselectGroup() {
      if (this.selectedGroupId) {
        const node = this.stage.findOne(`#${this.selectedGroupId}`)
        if (node) {
          node.stopDrag()
          node.draggable(false)
          node.off('dragmove.select')
        }
      }

      this._ClearHighlight('selected')
      this._ClearHighlight('hover')
      this._SetCursor('default')
      this.selectedGroupId = null
      this.hoveredGroupId = null
      this.isDragging = false
      this._hasDragged = false
      this._ignoreClick = false
      this._isMouseDown = false

      // Deseleccionar bloque y texto editado si hay uno
      this._DeselectBlock()
      this._DeselectTxt()
    },

    handleKeyDown(e) {
      if (!this.designMode) return

      // Si esta dibujando, delegar al keydown de dibujo
      if (this.isDrawing) {
        this.handleDrawingKeyDown(e)
        return
      }

      if (!this.selectedGroupId) return

      const arrowKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']
      if (!arrowKeys.includes(e.key)) return

      e.preventDefault()

      // Si está en drag con mouse, detenerlo
      if (this.isDragging) {
        const dragNode = this.stage.findOne(`#${this.selectedGroupId}`)
        if (dragNode) {
          dragNode.stopDrag()
          dragNode.draggable(false)
          dragNode.off('dragmove.select')
        }
        this.isDragging = false
      }

      const node = this.stage.findOne(`#${this.selectedGroupId}`)
      if (!node) return

      // Shift = 10px, normal = 1px
      const step = e.shiftKey ? 10 : 1

      switch (e.key) {
        case 'ArrowUp':    node.y(node.y() - step); break
        case 'ArrowDown':  node.y(node.y() + step); break
        case 'ArrowLeft':  node.x(node.x() - step); break
        case 'ArrowRight': node.x(node.x() + step); break
      }

      // Actualizar highlight a la nueva posición
      this._ClearHighlight('selected')
      this._ApplyHighlight(node, 'selected')

      this.$refs.layer.getNode().batchDraw()
    },

    _ApplyHighlight(group, type = 'hover', padding = 4) {
      const box = group.getClientRect({ relativeTo: group })

      const styles = {
        hover: {
          fill: 'rgba(52, 152, 219, 0.18)',
          stroke: 'rgba(52, 152, 219, 0.9)',
          strokeWidth: 2,
        },
        selected: {
          fill: 'rgba(52, 152, 219, 0.15)',
          stroke: 'rgba(52, 152, 219, 0.8)',
          strokeWidth: 2,
        }
      }

      const style = styles[type]

      const highlight = new Konva.Rect({
        name: 'highlight_' + type,
        x: box.x - padding,
        y: box.y - padding,
        width: box.width + padding * 2,
        height: box.height + padding * 2,
        fill: style.fill,
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
        strokeScaleEnabled: false, // grosor constante en pantalla (no engorda con el zoom)
        cornerRadius: 3,
        listening: false,
      })

      group.add(highlight)
      highlight.moveToBottom()
    },

    _ClearHighlight(type = null) {
      const layer = this.$refs.layer?.getNode()
      if (!layer) return

      if (type) {
        layer.find('.highlight_' + type).forEach(node => node.destroy())
      } else {
        layer.find('.highlight_hover').forEach(node => node.destroy())
        layer.find('.highlight_selected').forEach(node => node.destroy())
      }
    },

    handleClickOld(e) {
      if (! this.designMode)
        return

      // const stage = this.$refs.stage.getNode();
      // console.log(' e.target.getParent().className: ',  e.target.getParent().getType())
      // console.log(' e.target.getParent().className: ',  e.target.getParent().width())
      // console.log(' e.target.getParent().className: ',  e.target.getParent().height())

      // clicked on stage - clear selection
      // if (e.target === e.target.getStage()) {
      if (e.target === this.stage) {
        // this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      const node = e.target.findAncestor('.groupPictogram', true);
      // console.log('node: ', node)

      // var clickedGroup = e.target.findAncestor('Group');
      //descomentar esto luego
      // if (node) {
      //   // transformer.nodes([clickedGroup]);
      //   this.updateTransformer(node);
      //   // layer.draw();
      // }

      // find clicked rect by its name
      // const name = e.target.name();
      // console.log( name )
      // const rect = this.rectangles.find((r) => r.name === name);
      // if (rect) {
      //   this.selectedShapeName = name;
      // } else {
      //   this.selectedShapeName = '';
      // }
      // this.updateTransformer(node);
    },

    updateTransformer(node=null) {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      // const selectedNode = stage.findOne('.' + selectedShapeName);
      // // do nothing if selected node is already attached
      // if (selectedNode === transformerNode.node()) {
      //   return;
      // }

      if (node === transformerNode.node()) {
        return;
      }


      // if (selectedNode) {
      if (node) {
        // attach to another node
        // transformerNode.nodes([selectedNode]);
        transformerNode.nodes([node]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
    },

    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
    //   const rect = this.rectangles.find(
    //     (r) => r.name === this.selectedShapeName
    //   );
    //   // update the state
    //   rect.x = e.target.x();
    //   rect.y = e.target.y();
    //   rect.rotation = e.target.rotation();
    //   rect.scaleX = e.target.scaleX();
    //   rect.scaleY = e.target.scaleY();

    //   // change fill
    //   rect.fill = Konva.Util.getRandomColor();
    },

    handleDragStart() {
      this.isDragging = true;
    },
    handleDragEnd() {
      this.isDragging = false;
    },
    _GetImageConfig(obj) {
      let config = {
        neme: 'pic_' + obj.id,
        id: 'pic_' + obj.id
      }

      this.imageConfig.name = 'pic_' + obj.id
      this.imageConfig.id = 'pic_' + obj.id // asignamos igual para buscar por #id
      config.x = obj.x ? obj.x : this.imageConfig.x
      config.y = obj.y ? obj.y : this.imageConfig.y
      config.width = this.imageConfig.width
      config.height = this.imageConfig.height

      if (obj.rotation) {
        config.rotation = obj.rotation
      }
      return config
    },
  },

    created() {
      this.uppy = new Uppy({
        debug: process.env.NODE_ENV === 'development', // activamos debug para development
        autoProceed: false,
        allowMultipleUploads: true,
      })
      .use(AwsS3, {
        shouldUseMultipart: true,
        limit: 3,
        companionUrl: '/api/v2/',
        endpoint: '/api/v2/',
        headers: {
          'Authorization': "Bearer " + store.getters["auth/token"]
        }
      })
      // .on('upload-success', (file, response) => { this.onUploadSuccess(file, response) } )
      .on('upload-success', (file, response) => { // callback deveulto cuando el file ha sido subido correctamente
        console.log('%cEPC-TACKER: '+ '%c file ' + file.data.name + ' subido correctamente', 'background: #5577BB; color: #fff', 'color: #000')
      })
      .on('upload-progress', (file, progesss) => { // callback devuelto con el progreso de subido del archivo
        this.uploadPercentage = parseInt(
          Math.round((progesss.bytesUploaded * 100) / progesss.bytesTotal)
        );
      })
      .on('upload-error', (file, error, response) => { // callback devuelto si ha ocurrido algun error en la subida
        console.error('%cEPC-TACKER: '+ '%c a ocurrido un error al subir el archivo ' + file.data.name, 'background: #5577BB; color: #fff', 'color: #000', error)
      })

    },

    mounted() {
      this._navigationMode = false // candado: edición por defecto
      this.stage = this.$refs.stage.getStage()
      this.engine = new KonvaViewer(this.$refs.canvasContainer, this.stage)
      // Pan por defecto en modo vista (arrastrar el lienzo): activamos el draggable del
      // stage SIN _isPanMode (que suprimiría el hover de bloques/elementos). En diseño el
      // pan va por el candado (navegación), así que ahí queda OFF.
      this.stage.draggable(!this.designMode)
      this.Load()

      window.addEventListener('resize', this.handleResize);
      window.addEventListener('keydown', this.handleKeyDown);

      // Aviso (Pusher) de que el binario del parque terminó de regenerarse → recargar
      // la vista activa desde el binario fresco (swap atómico al concluir el Job).
      EventBus.$on('powerPlantBinaryReady', this._OnBinaryReady)

      this.$emit('epc-mounted')
    },

    beforeDestroy() {
      // Deseleccionar grupo activo antes de destruir
      this._DeselectGroup()

      // Limpiar event listeners
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('keydown', this.handleKeyDown)
      EventBus.$off('powerPlantBinaryReady', this._OnBinaryReady)

      // Cerrar Uppy para liberar recursos
      if (this.uppy) {
        this.uppy.destroy()
        this.uppy = null
      }

      // Destruir el viewer de Konva
      if (this.engine) {
        this.engine.Destroy()
        this.engine = null
      }

      // Soltar referencias a estructuras grandes para que el GC las recupere al cerrar
      // (sobre todo en el modal, que se abre/cierra: scenes puede pesar decenas de MB).
      this.scenes = {}
      this.pics = []
      this.powerPlant = { id: 0, name: null }
      this._viewStatusData = null
      this.hoverCallout = null
      this.selectedElement = null
      this._entityHoverRect = null
      this._entitySelectedRect = null
      this.blocks = []
      this.txtBlocks = []
      this.stage = null
    }
}
</script>

<style scoped>

.canvasContainer {
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 100px;
    min-height: 100px;

    background-color: #fefefe;
    .progress {
        position: absolute;
        z-index: 20;
        width: 90%;
        margin: 20px 5%;

        .progressText {
            margin: 10px 20px;
            font-size: 14px;
            color: #262d33;
            text-align: center;
        }
    }

    .error {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 20;
        padding: 30px;

        img {
            width: 24px;
            height: 24px;
            vertical-align: middle;
            margin: 4px;
        }
    }
}

</style>
